import { GraphqlError, FieldValueType } from '@/graphql/config'
import { AnalyzeResultOperationOutput, DocumentFieldTypeOutput } from '@azure-rest/ai-document-intelligence'

import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { useFetcher } from '@/graphql/config';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** AnalyzeResultOutputJson */
  AnalyzeResultOutputJson: { input: AnalyzeResultOperationOutput; output: AnalyzeResultOperationOutput; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** DocumentFieldType */
  DocumentFieldType: { input: DocumentFieldTypeOutput; output: DocumentFieldTypeOutput; }
  /** FieldKeyStyle */
  FieldKeyStyle: { input: {
  grid?: number;
  index: number;
  lines?: number;
  prefix?: string;
  suffix?: string;
  thousandSeparator?: boolean;
  isHidden?: boolean;
  pattern?: string;
  defaultValue?: FieldValueType;
  fieldLabel?: string;
  calculator?: string
  calculatorRelatedKeys?: string[]
  availableIf?: {
    keyName: string;
    value: FieldValueType[] | FieldValueType;
  }[];
  isSpace?: boolean;
  specialFunctionName?:
    | "isInDisasterProneDevelopedResidentialArea"
    | "isInSedimentDisasterAlertAreas"
    | "isInTsunamiDisasterAlertAreas"
    | "isInFloodArea"
    | "isInNaisuiArea"
    | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
}
; output: {
  grid?: number;
  index: number;
  lines?: number;
  prefix?: string;
  suffix?: string;
  thousandSeparator?: boolean;
  isHidden?: boolean;
  pattern?: string;
  defaultValue?: FieldValueType;
  fieldLabel?: string;
  calculator?: string
  calculatorRelatedKeys?: string[]
  availableIf?: {
    keyName: string;
    value: FieldValueType[] | FieldValueType;
  }[];
  isSpace?: boolean;
  specialFunctionName?:
    | "isInDisasterProneDevelopedResidentialArea"
    | "isInSedimentDisasterAlertAreas"
    | "isInTsunamiDisasterAlertAreas"
    | "isInFloodArea"
    | "isInNaisuiArea"
    | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
}
; }
  /** fieldValueType */
  FieldValueType: { input: FieldValueType; output: FieldValueType; }
  /** JsonObject */
  JsonObject: { input: any; output: any; }
};

export type AddressInfo = {
  __typename?: 'AddressInfo';
  hazardMapLinks?: Maybe<Array<HazardMapLinkPresenter>>;
  isInDisasteProneDevelopedResidentialArea: Scalars['Boolean']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  zoom: Scalars['Float']['output'];
};

export type AnalyzeFilePresenter = {
  __typename?: 'AnalyzeFilePresenter';
  fields: Array<ZyusetuFieldSectionPresenter>;
  file: FilePresenter;
};

export enum AnalyzerType {
  Azure = 'Azure',
  DocumentAi = 'DocumentAi',
  Gemini = 'Gemini'
}

export type ApprovalFlowPresenter = {
  __typename?: 'ApprovalFlowPresenter';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  steps: Array<ApprovalStepPresenter>;
};

export enum ApprovalStatus {
  Approved = 'Approved',
  Draft = 'Draft',
  InReview = 'InReview',
  Rejected = 'Rejected'
}

export type ApprovalStepExecutionPresenter = {
  __typename?: 'ApprovalStepExecutionPresenter';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: ApprovalStepStatus;
  user: UserPresenter;
  userId: Scalars['String']['output'];
};

export type ApprovalStepInput = {
  approverId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  stepOrder: Scalars['Float']['input'];
};

export type ApprovalStepPresenter = {
  __typename?: 'ApprovalStepPresenter';
  approver: UserPresenter;
  approverId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  stepExecution: Array<ApprovalStepExecutionPresenter>;
  stepOrder: Scalars['Float']['output'];
};

export enum ApprovalStepStatus {
  Approved = 'Approved',
  PendingApproval = 'PendingApproval',
  Rejected = 'Rejected'
}

export type BankAccountPresenter = {
  __typename?: 'BankAccountPresenter';
  accountHolderName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  branchName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
};

export type CreateApprovalFlowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  steps: Array<ApprovalStepInput>;
};

export type CreateBankAccountInput = {
  accountHolderName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  accountType: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  branchName: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManagementCompanyInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  registrationNumber: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRealEstateBrokerInput = {
  licenseNumber: Scalars['String']['input'];
  mainOfficeAddress: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  representativeName: Scalars['String']['input'];
};

export type CreateRealEstateTransactionSpecialistInput = {
  name: Scalars['String']['input'];
  officeAddress: Scalars['String']['input'];
  officeName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  registrationNumber: Scalars['String']['input'];
};

export type CreateZyusetuValueTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['FieldValueType']['input'];
};

export enum FileAnalyzeStatus {
  Analyzed = 'Analyzed',
  Analyzing = 'Analyzing',
  Failed = 'Failed',
  Pending = 'Pending'
}

export type FilePresenter = {
  __typename?: 'FilePresenter';
  analyzeStatus: FileAnalyzeStatus;
  azureAnalyzeResult?: Maybe<Scalars['AnalyzeResultOutputJson']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  fileName: Scalars['String']['output'];
  fileType: FileType;
  handRotation?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  pageData?: Maybe<Scalars['JsonObject']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export enum FileType {
  ManagementBylaw = 'ManagementBylaw',
  Mousikomi = 'Mousikomi',
  ReinsText = 'ReinsText',
  Result = 'Result',
  SalesBuildingTouki = 'SalesBuildingTouki',
  SalesLandTouki = 'SalesLandTouki',
  Touki = 'Touki',
  ZentakuZumen = 'ZentakuZumen',
  Zumen = 'Zumen',
  Zyusetu = 'Zyusetu',
  ZyusetuResearchReport = 'ZyusetuResearchReport'
}

export enum GenerateZyusetuContentType {
  Touki = 'Touki'
}

export type HazardMapLinkPresenter = {
  __typename?: 'HazardMapLinkPresenter';
  type: HazardMapType;
  url: Scalars['String']['output'];
};

export enum HazardMapType {
  FloodArea = 'FloodArea',
  HightideArea = 'HightideArea',
  NaisuiArea = 'NaisuiArea'
}

export type ManagementCompanyPresenter = {
  __typename?: 'ManagementCompanyPresenter';
  address: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  registrationNumber: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  analyzeFile?: Maybe<AnalyzeFilePresenter>;
  analyzeZyusetuFiles?: Maybe<ZyusetuPresenter>;
  approveStep?: Maybe<ZyusetuPresenter>;
  createApprovalFlow: ApprovalFlowPresenter;
  createBankAccount: BankAccountPresenter;
  createFileFromText?: Maybe<FilePresenter>;
  createManagementCompany: ManagementCompanyPresenter;
  createRealEstateBroker: RealEstateBrokerPresenter;
  createRealEstateTransactionSpecialist: RealEstateTransactionSpecialistPresenter;
  createUser?: Maybe<UserAdminPresenter>;
  createZyusetu?: Maybe<ZyusetuPresenter>;
  createZyusetuDocument?: Maybe<FilePresenter>;
  createZyusetuValueTemplate: ZyusetuFieldKeyValueTemplatePresenter;
  deleteApprovalFlow: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  deleteZyusetuDefaultValue: Scalars['Boolean']['output'];
  deleteZyusetuValueTemplate: Scalars['Boolean']['output'];
  generateZyusetuContentString: Scalars['String']['output'];
  inactivateFile: Scalars['Boolean']['output'];
  requestApprove?: Maybe<ApprovalFlowPresenter>;
  restoreApprovalFlow: Scalars['Boolean']['output'];
  restoreUser?: Maybe<Scalars['Boolean']['output']>;
  setOrganizationDefaultApprovalFlow: Scalars['Boolean']['output'];
  setRealEstateBrokerToZyusetu: Scalars['Boolean']['output'];
  setRealEstateTransactionSpecialistToZyusetu: Scalars['Boolean']['output'];
  setRole?: Maybe<UserAdminPresenter>;
  setUserDefaultApprovalFlow: Scalars['Boolean']['output'];
  undoApprovedStatus?: Maybe<Scalars['Boolean']['output']>;
  undoRequestApprove: Scalars['Boolean']['output'];
  updateApprovalFlow: ApprovalFlowPresenter;
  updateBankAccount: BankAccountPresenter;
  updateManagementCompany: ManagementCompanyPresenter;
  updateOrganizationApprovalFlowSettings: Scalars['Boolean']['output'];
  updateRotation?: Maybe<FilePresenter>;
  updateZyusetuDefaultValue: Scalars['String']['output'];
  updateZyusetuValue: Scalars['Boolean']['output'];
  updateZyusetuValueByApproveStep: Scalars['Boolean']['output'];
  updateZyusetuValueTemplate: ZyusetuFieldKeyValueTemplatePresenter;
  verifyZyusetuValue?: Maybe<ZyusetuPresenter>;
};


export type MutationAnalyzeFileArgs = {
  id: Scalars['String']['input'];
  zyusetuType: ZyusetuType;
};


export type MutationAnalyzeZyusetuFilesArgs = {
  fileIds: Array<Scalars['String']['input']>;
  zyusetuId: Scalars['String']['input'];
};


export type MutationApproveStepArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  executionId: Scalars['String']['input'];
  result: ApprovalStepStatus;
  zyusetuId: Scalars['String']['input'];
};


export type MutationCreateApprovalFlowArgs = {
  input: CreateApprovalFlowInput;
};


export type MutationCreateBankAccountArgs = {
  input: CreateBankAccountInput;
};


export type MutationCreateFileFromTextArgs = {
  fileType: FileType;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  zyusetuId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateManagementCompanyArgs = {
  input: CreateManagementCompanyInput;
};


export type MutationCreateRealEstateBrokerArgs = {
  input: CreateRealEstateBrokerInput;
};


export type MutationCreateRealEstateTransactionSpecialistArgs = {
  input: CreateRealEstateTransactionSpecialistInput;
};


export type MutationCreateUserArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  roleIds: Array<Scalars['String']['input']>;
};


export type MutationCreateZyusetuArgs = {
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  templateId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateZyusetuDocumentArgs = {
  zyusetuId: Scalars['String']['input'];
};


export type MutationCreateZyusetuValueTemplateArgs = {
  input: CreateZyusetuValueTemplateInput;
  keyId: Scalars['String']['input'];
};


export type MutationDeleteApprovalFlowArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteZyusetuDefaultValueArgs = {
  zyusetuDefaultValueId: Scalars['String']['input'];
};


export type MutationDeleteZyusetuValueTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationGenerateZyusetuContentStringArgs = {
  content: Scalars['String']['input'];
  type: GenerateZyusetuContentType;
};


export type MutationInactivateFileArgs = {
  id: Scalars['String']['input'];
  zyusetuId: Scalars['String']['input'];
};


export type MutationRequestApproveArgs = {
  zyusetuId: Scalars['String']['input'];
};


export type MutationRestoreApprovalFlowArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSetOrganizationDefaultApprovalFlowArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetRealEstateBrokerToZyusetuArgs = {
  brokerIds: Array<Scalars['String']['input']>;
  zyusetuId: Scalars['String']['input'];
};


export type MutationSetRealEstateTransactionSpecialistToZyusetuArgs = {
  specialistIds: Array<Scalars['String']['input']>;
  zyusetuId: Scalars['String']['input'];
};


export type MutationSetRoleArgs = {
  roleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationSetUserDefaultApprovalFlowArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationUndoApprovedStatusArgs = {
  zyusetuId: Scalars['String']['input'];
};


export type MutationUndoRequestApproveArgs = {
  zyusetuId: Scalars['String']['input'];
};


export type MutationUpdateApprovalFlowArgs = {
  input: UpdateApprovalFlowInput;
};


export type MutationUpdateBankAccountArgs = {
  id: Scalars['String']['input'];
  input: CreateBankAccountInput;
};


export type MutationUpdateManagementCompanyArgs = {
  id: Scalars['String']['input'];
  input: CreateManagementCompanyInput;
};


export type MutationUpdateOrganizationApprovalFlowSettingsArgs = {
  useApprovalFlow: Scalars['Boolean']['input'];
};


export type MutationUpdateRotationArgs = {
  id: Scalars['String']['input'];
  rotation: Scalars['Float']['input'];
};


export type MutationUpdateZyusetuDefaultValueArgs = {
  keyId: Scalars['String']['input'];
  value: Scalars['FieldValueType']['input'];
  zyusetuDefaultValueId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateZyusetuValueArgs = {
  keyId: Scalars['String']['input'];
  payloadId?: InputMaybe<Scalars['String']['input']>;
  templateDescription?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['FieldValueType']['input'];
  zyusetuId: Scalars['String']['input'];
};


export type MutationUpdateZyusetuValueByApproveStepArgs = {
  keyId: Scalars['String']['input'];
  payloadId?: InputMaybe<Scalars['String']['input']>;
  stepExecutionId: Scalars['String']['input'];
  templateDescription?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['FieldValueType']['input'];
  zyusetuId: Scalars['String']['input'];
};


export type MutationUpdateZyusetuValueTemplateArgs = {
  id: Scalars['String']['input'];
  input: CreateZyusetuValueTemplateInput;
};


export type MutationVerifyZyusetuValueArgs = {
  input: Array<VerifyZyusetuValueInput>;
  zyusetuId: Scalars['String']['input'];
};

export type OrganizationPresenter = {
  __typename?: 'OrganizationPresenter';
  createdAt: Scalars['DateTimeISO']['output'];
  defaultApprovalFlowId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  usage?: Maybe<OrganizationUsagePresenter>;
  usageLimit?: Maybe<OrganizationUsageLimitPresenter>;
  useApprovalFlow: Scalars['Boolean']['output'];
};

export type OrganizationUsageLimitPresenter = {
  __typename?: 'OrganizationUsageLimitPresenter';
  id: Scalars['String']['output'];
  managementByRawAnalyzeCount: Scalars['Float']['output'];
  plan: UsagePlanType;
  zumenAnalyzeCount: Scalars['Float']['output'];
  zyusetuCount: Scalars['Float']['output'];
};

export type OrganizationUsagePresenter = {
  __typename?: 'OrganizationUsagePresenter';
  id: Scalars['String']['output'];
  managementByRawAnalyzeCount: Scalars['Float']['output'];
  month: Scalars['String']['output'];
  zumenAnalyzeCount: Scalars['Float']['output'];
  zyusetuCount: Scalars['Float']['output'];
};

export type PaginateInput = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};

export type PaginatedZyusetuSimplePresenter = {
  __typename?: 'PaginatedZyusetuSimplePresenter';
  items: Array<ZyusetuSimplePresenter>;
  total: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  getAddressInfo?: Maybe<AddressInfo>;
  getApprovalFlowById?: Maybe<ApprovalFlowPresenter>;
  getApprovalFlows: Array<ApprovalFlowPresenter>;
  getBankAccount: BankAccountPresenter;
  getFileById?: Maybe<FilePresenter>;
  getManagementCompany: ManagementCompanyPresenter;
  getPendingReviewCount: Scalars['Float']['output'];
  getPendingReviews?: Maybe<PaginatedZyusetuSimplePresenter>;
  getUser?: Maybe<UserAdminPresenter>;
  getZyusetuById?: Maybe<ZyusetuPresenter>;
  getZyusetuByStepExecutionId?: Maybe<ZyusetuPresenter>;
  getZyusetuSimple?: Maybe<PaginatedZyusetuSimplePresenter>;
  listUsers: Array<UserAdminPresenter>;
  me?: Maybe<UserPresenter>;
  searchBankAccounts: Array<BankAccountPresenter>;
  searchManagementCompanies: Array<ManagementCompanyPresenter>;
  searchRealEstateBrokers: Array<RealEstateBrokerPresenter>;
  searchRealEstateTransactionSpecialists: Array<RealEstateTransactionSpecialistPresenter>;
  searchUsers: Array<UserPresenter>;
  searchZyusetuTemplates: Array<ZyusetuTemplatePresenter>;
};


export type QueryGetAddressInfoArgs = {
  address: Scalars['String']['input'];
};


export type QueryGetApprovalFlowByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetBankAccountArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetFileByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetManagementCompanyArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPendingReviewCountArgs = {
  status?: InputMaybe<ApprovalStepStatus>;
};


export type QueryGetPendingReviewsArgs = {
  paginate: PaginateInput;
  status?: InputMaybe<ApprovalStepStatus>;
};


export type QueryGetUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetZyusetuByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetZyusetuByStepExecutionIdArgs = {
  executionId: Scalars['String']['input'];
};


export type QueryGetZyusetuSimpleArgs = {
  paginate?: InputMaybe<PaginateInput>;
  search?: InputMaybe<ZyusetuSearchInput>;
};


export type QuerySearchBankAccountsArgs = {
  searchString: Scalars['String']['input'];
};


export type QuerySearchManagementCompaniesArgs = {
  searchString: Scalars['String']['input'];
};


export type QuerySearchRealEstateBrokersArgs = {
  searchString: Scalars['String']['input'];
};


export type QuerySearchRealEstateTransactionSpecialistsArgs = {
  searchString: Scalars['String']['input'];
};


export type QuerySearchUsersArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchZyusetuTemplatesArgs = {
  rentGuaranteeType?: InputMaybe<RentGuaranteeType>;
  rentType?: InputMaybe<RentType>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  zyusetuType: ZyusetuType;
};

export type RealEstateBrokerPresenter = {
  __typename?: 'RealEstateBrokerPresenter';
  id: Scalars['String']['output'];
  licenseNumber: Scalars['String']['output'];
  mainOfficeAddress: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  representativeName: Scalars['String']['output'];
};

export type RealEstateTransactionSpecialistPresenter = {
  __typename?: 'RealEstateTransactionSpecialistPresenter';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  officeAddress: Scalars['String']['output'];
  officeName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  registrationNumber: Scalars['String']['output'];
};

export enum RentGuaranteeType {
  GuaranteeCompany = 'GuaranteeCompany',
  GuaranteeCompanyAndGuarantor = 'GuaranteeCompanyAndGuarantor',
  Guarantor = 'Guarantor'
}

export enum RentType {
  NormalRent = 'NormalRent',
  FixedTermRent = 'fixedTermRent'
}

export type UpdateApprovalFlowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  steps: Array<ApprovalStepInput>;
};

export enum UsagePlanType {
  Free = 'Free',
  Paid = 'Paid'
}

export type UserAdminPresenter = {
  __typename?: 'UserAdminPresenter';
  auth0Id?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  defaultApprovalFlow?: Maybe<ApprovalFlowPresenter>;
  defaultApprovalFlowId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<OrganizationPresenter>;
  organizationId: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

export type UserPresenter = {
  __typename?: 'UserPresenter';
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<OrganizationPresenter>;
  organizationId: Scalars['String']['output'];
};

export type VerifyZyusetuValueInput = {
  keyId: Scalars['String']['input'];
  payloadId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['FieldValueType']['input']>;
};

export type ZyusetuFieldChangedValuePresenter = {
  __typename?: 'ZyusetuFieldChangedValuePresenter';
  approvalStepExecutionId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  isVerified: Scalars['Boolean']['output'];
  selectedPayload?: Maybe<ZyusetuFieldValueAnalyzedPayloadPresenter>;
  templateDescription?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['FieldValueType']['output']>;
};

export type ZyusetuFieldDefaultValuePresenter = {
  __typename?: 'ZyusetuFieldDefaultValuePresenter';
  id: Scalars['String']['output'];
  value: Scalars['FieldValueType']['output'];
};

export type ZyusetuFieldKeyPresenter = {
  __typename?: 'ZyusetuFieldKeyPresenter';
  analyzedPayloads?: Maybe<Array<ZyusetuFieldValueAnalyzedPayloadPresenter>>;
  changedValues?: Maybe<Array<ZyusetuFieldChangedValuePresenter>>;
  defaultValue?: Maybe<Array<ZyusetuFieldDefaultValuePresenter>>;
  description?: Maybe<Scalars['String']['output']>;
  generator?: Maybe<GenerateZyusetuContentType>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  items?: Maybe<Array<Scalars['String']['output']>>;
  keyName: Scalars['String']['output'];
  keyStyle: Scalars['FieldKeyStyle']['output'];
  keyType: ZyusetuFieldKeyType;
  label: Scalars['String']['output'];
  value?: Maybe<ZyusetuFieldValuePresenter>;
  valueTemplate: Array<ZyusetuFieldKeyValueTemplatePresenter>;
};

export enum ZyusetuFieldKeyType {
  AutoCompleteBankAccount = 'AutoCompleteBankAccount',
  AutoCompleteManagementCompany = 'AutoCompleteManagementCompany',
  Boolean = 'Boolean',
  Date = 'Date',
  DateMonth = 'DateMonth',
  Number = 'Number',
  PremisesLandRights = 'PremisesLandRights',
  Select = 'Select',
  SelectMany = 'SelectMany',
  SelectManyWithCustomInput = 'SelectManyWithCustomInput',
  String = 'String',
  StringArray = 'StringArray',
  StringAutoComplete = 'StringAutoComplete',
  Tenant = 'Tenant'
}

export type ZyusetuFieldKeyValueTemplatePresenter = {
  __typename?: 'ZyusetuFieldKeyValueTemplatePresenter';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  value: Scalars['FieldValueType']['output'];
};

export type ZyusetuFieldSectionPresenter = {
  __typename?: 'ZyusetuFieldSectionPresenter';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  index: Scalars['Float']['output'];
  keys: Array<ZyusetuFieldKeyPresenter>;
  title: Scalars['String']['output'];
};

export type ZyusetuFieldValueAnalyzedPayloadPresenter = {
  __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter';
  analyzedFileId?: Maybe<Scalars['String']['output']>;
  azureFieldOutput?: Maybe<Scalars['JsonObject']['output']>;
  azureFieldType?: Maybe<Scalars['DocumentFieldType']['output']>;
  boundingRegions?: Maybe<Scalars['JsonObject']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  content?: Maybe<Scalars['FieldValueType']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  normalizedContent?: Maybe<Scalars['FieldValueType']['output']>;
  pageAnchor?: Maybe<Scalars['JsonObject']['output']>;
  properties?: Maybe<Scalars['JsonObject']['output']>;
  type: AnalyzerType;
};

export type ZyusetuFieldValuePresenter = {
  __typename?: 'ZyusetuFieldValuePresenter';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  isVerified: Scalars['Boolean']['output'];
  selectedPayload?: Maybe<ZyusetuFieldValueAnalyzedPayloadPresenter>;
  templateDescription?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['FieldValueType']['output']>;
};

export type ZyusetuPresenter = {
  __typename?: 'ZyusetuPresenter';
  approvalFlow?: Maybe<ApprovalFlowPresenter>;
  approvalFlowId?: Maybe<Scalars['String']['output']>;
  approvalStatus: ApprovalStatus;
  createdAt: Scalars['DateTimeISO']['output'];
  files: Array<FilePresenter>;
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  realEstateBrokers: Array<RealEstateBrokerPresenter>;
  realEstateTransactionSpecialists: Array<RealEstateTransactionSpecialistPresenter>;
  template: ZyusetuTemplatePresenter;
  title?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserPresenter>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ZyusetuSearchInput = {
  approvalStatus?: InputMaybe<ApprovalStatus>;
  createdAtEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdAtStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
  templateTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ZyusetuSimplePresenter = {
  __typename?: 'ZyusetuSimplePresenter';
  approvalStatus: ApprovalStatus;
  approvalStepExecution?: Maybe<ApprovalStepExecutionPresenter>;
  approvalStepExecutionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  files: Array<FilePresenter>;
  id: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  templateTitle: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserPresenter>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ZyusetuTemplatePresenter = {
  __typename?: 'ZyusetuTemplatePresenter';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  optionalFileTypes: Array<FileType>;
  rentGuaranteeType?: Maybe<RentGuaranteeType>;
  rentType?: Maybe<RentType>;
  requiredFileTypes: Array<FileType>;
  sections: Array<ZyusetuFieldSectionPresenter>;
  title: Scalars['String']['output'];
  type: ZyusetuType;
};

export enum ZyusetuType {
  InternalManagementBylaw = 'InternalManagementBylaw',
  Rent = 'Rent',
  Sale = 'Sale'
}

export type UserAdminFieldsFragment = { __typename?: 'UserAdminPresenter', id: string, name: string, email: string, roles: Array<string>, auth0Id?: string | null, organizationId: string, isDeleted: boolean, createdAt: string, defaultApprovalFlowId?: string | null, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null } | null, defaultApprovalFlow?: { __typename?: 'ApprovalFlowPresenter', id: string, name: string, description?: string | null, isDeleted: boolean, steps: Array<{ __typename?: 'ApprovalStepPresenter', id: string, name: string, description?: string | null, stepOrder: number, approverId: string, isDeleted: boolean, approver: { __typename?: 'UserPresenter', id: string, name: string, email: string, organizationId: string } }> } | null };

export type ListUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUsersQuery = { __typename?: 'Query', listUsers: Array<{ __typename?: 'UserAdminPresenter', id: string, name: string, email: string, roles: Array<string>, auth0Id?: string | null, organizationId: string, isDeleted: boolean, createdAt: string, defaultApprovalFlowId?: string | null, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null } | null, defaultApprovalFlow?: { __typename?: 'ApprovalFlowPresenter', id: string, name: string, description?: string | null, isDeleted: boolean, steps: Array<{ __typename?: 'ApprovalStepPresenter', id: string, name: string, description?: string | null, stepOrder: number, approverId: string, isDeleted: boolean, approver: { __typename?: 'UserPresenter', id: string, name: string, email: string, organizationId: string } }> } | null }> };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'UserAdminPresenter', id: string, name: string, email: string, roles: Array<string>, auth0Id?: string | null, organizationId: string, isDeleted: boolean, createdAt: string, defaultApprovalFlowId?: string | null, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null } | null, defaultApprovalFlow?: { __typename?: 'ApprovalFlowPresenter', id: string, name: string, description?: string | null, isDeleted: boolean, steps: Array<{ __typename?: 'ApprovalStepPresenter', id: string, name: string, description?: string | null, stepOrder: number, approverId: string, isDeleted: boolean, approver: { __typename?: 'UserPresenter', id: string, name: string, email: string, organizationId: string } }> } | null } | null };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  roleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'UserAdminPresenter', id: string, name: string, email: string, roles: Array<string>, auth0Id?: string | null, organizationId: string, isDeleted: boolean, createdAt: string, defaultApprovalFlowId?: string | null, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null } | null, defaultApprovalFlow?: { __typename?: 'ApprovalFlowPresenter', id: string, name: string, description?: string | null, isDeleted: boolean, steps: Array<{ __typename?: 'ApprovalStepPresenter', id: string, name: string, description?: string | null, stepOrder: number, approverId: string, isDeleted: boolean, approver: { __typename?: 'UserPresenter', id: string, name: string, email: string, organizationId: string } }> } | null } | null };

export type SetRoleMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  roleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SetRoleMutation = { __typename?: 'Mutation', setRole?: { __typename?: 'UserAdminPresenter', id: string, name: string, email: string, roles: Array<string>, auth0Id?: string | null, organizationId: string, isDeleted: boolean, createdAt: string, defaultApprovalFlowId?: string | null, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null } | null, defaultApprovalFlow?: { __typename?: 'ApprovalFlowPresenter', id: string, name: string, description?: string | null, isDeleted: boolean, steps: Array<{ __typename?: 'ApprovalStepPresenter', id: string, name: string, description?: string | null, stepOrder: number, approverId: string, isDeleted: boolean, approver: { __typename?: 'UserPresenter', id: string, name: string, email: string, organizationId: string } }> } | null } | null };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type RestoreUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RestoreUserMutation = { __typename?: 'Mutation', restoreUser?: boolean | null };

export type ApprovalStepFieldsFragment = { __typename?: 'ApprovalStepPresenter', id: string, name: string, description?: string | null, stepOrder: number, approverId: string, isDeleted: boolean, approver: { __typename?: 'UserPresenter', id: string, name: string, email: string, organizationId: string } };

export type ApprovalFlowFieldsFragment = { __typename?: 'ApprovalFlowPresenter', id: string, name: string, description?: string | null, isDeleted: boolean, steps: Array<{ __typename?: 'ApprovalStepPresenter', id: string, name: string, description?: string | null, stepOrder: number, approverId: string, isDeleted: boolean, approver: { __typename?: 'UserPresenter', id: string, name: string, email: string, organizationId: string } }> };

export type GetApprovalFlowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApprovalFlowsQuery = { __typename?: 'Query', getApprovalFlows: Array<{ __typename?: 'ApprovalFlowPresenter', id: string, name: string, description?: string | null, isDeleted: boolean, steps: Array<{ __typename?: 'ApprovalStepPresenter', id: string, name: string, description?: string | null, stepOrder: number, approverId: string, isDeleted: boolean, approver: { __typename?: 'UserPresenter', id: string, name: string, email: string, organizationId: string } }> }> };

export type GetApprovalFlowByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetApprovalFlowByIdQuery = { __typename?: 'Query', getApprovalFlowById?: { __typename?: 'ApprovalFlowPresenter', id: string, name: string, description?: string | null, isDeleted: boolean, steps: Array<{ __typename?: 'ApprovalStepPresenter', id: string, name: string, description?: string | null, stepOrder: number, approverId: string, isDeleted: boolean, approver: { __typename?: 'UserPresenter', id: string, name: string, email: string, organizationId: string } }> } | null };

export type CreateApprovalFlowMutationVariables = Exact<{
  input: CreateApprovalFlowInput;
}>;


export type CreateApprovalFlowMutation = { __typename?: 'Mutation', createApprovalFlow: { __typename?: 'ApprovalFlowPresenter', id: string, name: string, description?: string | null, isDeleted: boolean, steps: Array<{ __typename?: 'ApprovalStepPresenter', id: string, name: string, description?: string | null, stepOrder: number, approverId: string, isDeleted: boolean, approver: { __typename?: 'UserPresenter', id: string, name: string, email: string, organizationId: string } }> } };

export type UpdateApprovalFlowMutationVariables = Exact<{
  input: UpdateApprovalFlowInput;
}>;


export type UpdateApprovalFlowMutation = { __typename?: 'Mutation', updateApprovalFlow: { __typename?: 'ApprovalFlowPresenter', id: string, name: string, description?: string | null, isDeleted: boolean, steps: Array<{ __typename?: 'ApprovalStepPresenter', id: string, name: string, description?: string | null, stepOrder: number, approverId: string, isDeleted: boolean, approver: { __typename?: 'UserPresenter', id: string, name: string, email: string, organizationId: string } }> } };

export type DeleteApprovalFlowMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteApprovalFlowMutation = { __typename?: 'Mutation', deleteApprovalFlow: boolean };

export type RestoreApprovalFlowMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreApprovalFlowMutation = { __typename?: 'Mutation', restoreApprovalFlow: boolean };

export type SetOrganizationDefaultApprovalFlowMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetOrganizationDefaultApprovalFlowMutation = { __typename?: 'Mutation', setOrganizationDefaultApprovalFlow: boolean };

export type SetUserDefaultApprovalFlowMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetUserDefaultApprovalFlowMutation = { __typename?: 'Mutation', setUserDefaultApprovalFlow: boolean };

export type UpdateOrganizationApprovalFlowSettingsMutationVariables = Exact<{
  useApprovalFlow: Scalars['Boolean']['input'];
}>;


export type UpdateOrganizationApprovalFlowSettingsMutation = { __typename?: 'Mutation', updateOrganizationApprovalFlowSettings: boolean };

export type AnalyzeFileMutationVariables = Exact<{
  fileId: Scalars['String']['input'];
  zyusetuType: ZyusetuType;
}>;


export type AnalyzeFileMutation = { __typename?: 'Mutation', analyzeFile?: { __typename?: 'AnalyzeFilePresenter', fields: Array<{ __typename?: 'ZyusetuFieldSectionPresenter', id: string, title: string, description?: string | null, index: number, keys: Array<{ __typename?: 'ZyusetuFieldKeyPresenter', id: string, keyName: string, label: string, isRequired: boolean, description?: string | null, keyStyle: {
        grid?: number;
        index: number;
        lines?: number;
        prefix?: string;
        suffix?: string;
        thousandSeparator?: boolean;
        isHidden?: boolean;
        pattern?: string;
        defaultValue?: FieldValueType;
        fieldLabel?: string;
        calculator?: string
        calculatorRelatedKeys?: string[]
        availableIf?: {
          keyName: string;
          value: FieldValueType[] | FieldValueType;
        }[];
        isSpace?: boolean;
        specialFunctionName?:
          | "isInDisasterProneDevelopedResidentialArea"
          | "isInSedimentDisasterAlertAreas"
          | "isInTsunamiDisasterAlertAreas"
          | "isInFloodArea"
          | "isInNaisuiArea"
          | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
      }
      , generator?: GenerateZyusetuContentType | null, keyType: ZyusetuFieldKeyType, items?: Array<string> | null, defaultValue?: Array<{ __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType }> | null, analyzedPayloads?: Array<{ __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any }> | null, value?: { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null } | null, changedValues?: Array<{ __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null }> | null, valueTemplate: Array<{ __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null }> }> }>, file: { __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null } } | null };

export type GetAddressInfoQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetAddressInfoQuery = { __typename?: 'Query', getAddressInfo?: { __typename?: 'AddressInfo', lat: number, lng: number, x: number, y: number, zoom: number, isInDisasteProneDevelopedResidentialArea: boolean, hazardMapLinks?: Array<{ __typename?: 'HazardMapLinkPresenter', url: string, type: HazardMapType }> | null } | null };

export type GenerateZyusetuContentStringMutationVariables = Exact<{
  content: Scalars['String']['input'];
  type: GenerateZyusetuContentType;
}>;


export type GenerateZyusetuContentStringMutation = { __typename?: 'Mutation', generateZyusetuContentString: string };

export type AddressInfoFragmentFragment = { __typename?: 'AddressInfo', lat: number, lng: number, x: number, y: number, zoom: number, isInDisasteProneDevelopedResidentialArea: boolean, hazardMapLinks?: Array<{ __typename?: 'HazardMapLinkPresenter', url: string, type: HazardMapType }> | null };

export type RequestApprovalMutationVariables = Exact<{
  zyusetuId: Scalars['String']['input'];
}>;


export type RequestApprovalMutation = { __typename?: 'Mutation', requestApprove?: { __typename?: 'ApprovalFlowPresenter', description?: string | null, id: string, name: string, steps: Array<{ __typename?: 'ApprovalStepPresenter', description?: string | null, id: string, name: string, approverId: string, stepOrder: number, stepExecution: Array<{ __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }>, approver: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }> } | null };

export type GetPendingReviewsQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type GetPendingReviewsQuery = { __typename?: 'Query', getPendingReviews?: { __typename?: 'PaginatedZyusetuSimplePresenter', total: number, items: Array<{ __typename?: 'ZyusetuSimplePresenter', createdAt: any, id: string, approvalStatus: ApprovalStatus, templateTitle: string, approvalStepExecutionId?: string | null, title?: string | null, userId?: string | null, files: Array<{ __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null }>, approvalStepExecution?: { __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } } | null, user?: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } | null }> } | null };

export type ApproveStepMutationVariables = Exact<{
  stepExecutionId: Scalars['String']['input'];
  result: ApprovalStepStatus;
  zyusetuId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApproveStepMutation = { __typename?: 'Mutation', approveStep?: { __typename?: 'ZyusetuPresenter', id: string, title?: string | null, createdAt: any, approvalStatus: ApprovalStatus, approvalFlowId?: string | null, user?: { __typename?: 'UserPresenter', id: string, name: string } | null, approvalFlow?: { __typename?: 'ApprovalFlowPresenter', description?: string | null, id: string, name: string, steps: Array<{ __typename?: 'ApprovalStepPresenter', description?: string | null, id: string, name: string, approverId: string, stepOrder: number, stepExecution: Array<{ __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }>, approver: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }> } | null, files: Array<{ __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null }>, template: { __typename?: 'ZyusetuTemplatePresenter', id: string, title: string, description?: string | null, type: ZyusetuType, rentType?: RentType | null, rentGuaranteeType?: RentGuaranteeType | null, requiredFileTypes: Array<FileType>, optionalFileTypes: Array<FileType>, sections: Array<{ __typename?: 'ZyusetuFieldSectionPresenter', id: string, title: string, description?: string | null, index: number, keys: Array<{ __typename?: 'ZyusetuFieldKeyPresenter', id: string, keyName: string, label: string, isRequired: boolean, description?: string | null, keyStyle: {
          grid?: number;
          index: number;
          lines?: number;
          prefix?: string;
          suffix?: string;
          thousandSeparator?: boolean;
          isHidden?: boolean;
          pattern?: string;
          defaultValue?: FieldValueType;
          fieldLabel?: string;
          calculator?: string
          calculatorRelatedKeys?: string[]
          availableIf?: {
            keyName: string;
            value: FieldValueType[] | FieldValueType;
          }[];
          isSpace?: boolean;
          specialFunctionName?:
            | "isInDisasterProneDevelopedResidentialArea"
            | "isInSedimentDisasterAlertAreas"
            | "isInTsunamiDisasterAlertAreas"
            | "isInFloodArea"
            | "isInNaisuiArea"
            | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
        }
        , generator?: GenerateZyusetuContentType | null, keyType: ZyusetuFieldKeyType, items?: Array<string> | null, defaultValue?: Array<{ __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType }> | null, analyzedPayloads?: Array<{ __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any }> | null, value?: { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null } | null, changedValues?: Array<{ __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null }> | null, valueTemplate: Array<{ __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null }> }> }> }, realEstateTransactionSpecialists: Array<{ __typename?: 'RealEstateTransactionSpecialistPresenter', id: string, name: string, officeAddress: string, officeName: string, phoneNumber: string, registrationNumber: string }>, realEstateBrokers: Array<{ __typename?: 'RealEstateBrokerPresenter', id: string, licenseNumber: string, mainOfficeAddress: string, name: string, phoneNumber: string, representativeName: string }> } | null };

export type UndoRequestApproveMutationVariables = Exact<{
  zyusetuId: Scalars['String']['input'];
}>;


export type UndoRequestApproveMutation = { __typename?: 'Mutation', undoRequestApprove: boolean };

export type UndoApprovedStatusMutationVariables = Exact<{
  zyusetuId: Scalars['String']['input'];
}>;


export type UndoApprovedStatusMutation = { __typename?: 'Mutation', undoApprovedStatus?: boolean | null };

export type GetZyusetuByApprovalExecutionIdQueryVariables = Exact<{
  executionId: Scalars['String']['input'];
}>;


export type GetZyusetuByApprovalExecutionIdQuery = { __typename?: 'Query', getZyusetuByStepExecutionId?: { __typename?: 'ZyusetuPresenter', id: string, title?: string | null, createdAt: any, approvalStatus: ApprovalStatus, approvalFlowId?: string | null, user?: { __typename?: 'UserPresenter', id: string, name: string } | null, approvalFlow?: { __typename?: 'ApprovalFlowPresenter', description?: string | null, id: string, name: string, steps: Array<{ __typename?: 'ApprovalStepPresenter', description?: string | null, id: string, name: string, approverId: string, stepOrder: number, stepExecution: Array<{ __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }>, approver: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }> } | null, files: Array<{ __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null }>, template: { __typename?: 'ZyusetuTemplatePresenter', id: string, title: string, description?: string | null, type: ZyusetuType, rentType?: RentType | null, rentGuaranteeType?: RentGuaranteeType | null, requiredFileTypes: Array<FileType>, optionalFileTypes: Array<FileType>, sections: Array<{ __typename?: 'ZyusetuFieldSectionPresenter', id: string, title: string, description?: string | null, index: number, keys: Array<{ __typename?: 'ZyusetuFieldKeyPresenter', id: string, keyName: string, label: string, isRequired: boolean, description?: string | null, keyStyle: {
          grid?: number;
          index: number;
          lines?: number;
          prefix?: string;
          suffix?: string;
          thousandSeparator?: boolean;
          isHidden?: boolean;
          pattern?: string;
          defaultValue?: FieldValueType;
          fieldLabel?: string;
          calculator?: string
          calculatorRelatedKeys?: string[]
          availableIf?: {
            keyName: string;
            value: FieldValueType[] | FieldValueType;
          }[];
          isSpace?: boolean;
          specialFunctionName?:
            | "isInDisasterProneDevelopedResidentialArea"
            | "isInSedimentDisasterAlertAreas"
            | "isInTsunamiDisasterAlertAreas"
            | "isInFloodArea"
            | "isInNaisuiArea"
            | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
        }
        , generator?: GenerateZyusetuContentType | null, keyType: ZyusetuFieldKeyType, items?: Array<string> | null, defaultValue?: Array<{ __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType }> | null, analyzedPayloads?: Array<{ __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any }> | null, value?: { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null } | null, changedValues?: Array<{ __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null }> | null, valueTemplate: Array<{ __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null }> }> }> }, realEstateTransactionSpecialists: Array<{ __typename?: 'RealEstateTransactionSpecialistPresenter', id: string, name: string, officeAddress: string, officeName: string, phoneNumber: string, registrationNumber: string }>, realEstateBrokers: Array<{ __typename?: 'RealEstateBrokerPresenter', id: string, licenseNumber: string, mainOfficeAddress: string, name: string, phoneNumber: string, representativeName: string }> } | null };

export type GetPendingReviewCountQueryVariables = Exact<{
  status?: InputMaybe<ApprovalStepStatus>;
}>;


export type GetPendingReviewCountQuery = { __typename?: 'Query', getPendingReviewCount: number };

export type UpdateZyusetuValueByApproveStepMutationVariables = Exact<{
  keyId: Scalars['String']['input'];
  payloadId?: InputMaybe<Scalars['String']['input']>;
  stepExecutionId: Scalars['String']['input'];
  templateDescription?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['FieldValueType']['input'];
  zyusetuId: Scalars['String']['input'];
}>;


export type UpdateZyusetuValueByApproveStepMutation = { __typename?: 'Mutation', updateZyusetuValueByApproveStep: boolean };

export type ApprovalFlowFragmentFragment = { __typename?: 'ApprovalFlowPresenter', description?: string | null, id: string, name: string, steps: Array<{ __typename?: 'ApprovalStepPresenter', description?: string | null, id: string, name: string, approverId: string, stepOrder: number, stepExecution: Array<{ __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }>, approver: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }> };

export type ApprovalStepFragmentFragment = { __typename?: 'ApprovalStepPresenter', description?: string | null, id: string, name: string, approverId: string, stepOrder: number, stepExecution: Array<{ __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }>, approver: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } };

export type ApprovalStepExecutionFragmentFragment = { __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } };

export type InactivateFileMutationVariables = Exact<{
  id: Scalars['String']['input'];
  zyusetuId: Scalars['String']['input'];
}>;


export type InactivateFileMutation = { __typename?: 'Mutation', inactivateFile: boolean };

export type UpdateRotationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  rotation: Scalars['Float']['input'];
}>;


export type UpdateRotationMutation = { __typename?: 'Mutation', updateRotation?: { __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null } | null };

export type CreateFileFromTextMutationVariables = Exact<{
  zyusetuId: Scalars['String']['input'];
  text: Scalars['String']['input'];
  fileType: FileType;
  title: Scalars['String']['input'];
}>;


export type CreateFileFromTextMutation = { __typename?: 'Mutation', createFileFromText?: { __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null } | null };

export type FileFragmentFragment = { __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null };

export type OrganizationFragmentFragment = { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null };

export type OrganizationUsageLimitFragmentFragment = { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType };

export type OrganizationUsageFragmentFragment = { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number };

export type RealEstateBrokerFragmentFragment = { __typename?: 'RealEstateBrokerPresenter', id: string, licenseNumber: string, mainOfficeAddress: string, name: string, phoneNumber: string, representativeName: string };

export type RealEstateTransactionSpecialistFragmentFragment = { __typename?: 'RealEstateTransactionSpecialistPresenter', id: string, name: string, officeAddress: string, officeName: string, phoneNumber: string, registrationNumber: string };

export type ManagementCompanyFragmentFragment = { __typename?: 'ManagementCompanyPresenter', id: string, name: string, address: string, phoneNumber: string, registrationNumber: string, remarks?: string | null };

export type BankAccountFragmentFragment = { __typename?: 'BankAccountPresenter', accountHolderName: string, accountNumber: string, accountType: string, bankName: string, branchName: string, id: string, remarks?: string | null };

export type SearchRealEstateTransactionSpecialistsQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
}>;


export type SearchRealEstateTransactionSpecialistsQuery = { __typename?: 'Query', searchRealEstateTransactionSpecialists: Array<{ __typename?: 'RealEstateTransactionSpecialistPresenter', id: string, name: string, officeAddress: string, officeName: string, phoneNumber: string, registrationNumber: string }> };

export type SearchRealEstateBrokersQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
}>;


export type SearchRealEstateBrokersQuery = { __typename?: 'Query', searchRealEstateBrokers: Array<{ __typename?: 'RealEstateBrokerPresenter', id: string, licenseNumber: string, mainOfficeAddress: string, name: string, phoneNumber: string, representativeName: string }> };

export type SearchManagementCompaniesQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
}>;


export type SearchManagementCompaniesQuery = { __typename?: 'Query', searchManagementCompanies: Array<{ __typename?: 'ManagementCompanyPresenter', id: string, name: string, address: string, phoneNumber: string, registrationNumber: string, remarks?: string | null }> };

export type GetManagementCompanyQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetManagementCompanyQuery = { __typename?: 'Query', getManagementCompany: { __typename?: 'ManagementCompanyPresenter', id: string, name: string, address: string, phoneNumber: string, registrationNumber: string, remarks?: string | null } };

export type CreateManagementCompanyMutationVariables = Exact<{
  input: CreateManagementCompanyInput;
}>;


export type CreateManagementCompanyMutation = { __typename?: 'Mutation', createManagementCompany: { __typename?: 'ManagementCompanyPresenter', id: string, name: string, address: string, phoneNumber: string, registrationNumber: string, remarks?: string | null } };

export type UpdateManagementCompanyMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: CreateManagementCompanyInput;
}>;


export type UpdateManagementCompanyMutation = { __typename?: 'Mutation', updateManagementCompany: { __typename?: 'ManagementCompanyPresenter', id: string, name: string, address: string, phoneNumber: string, registrationNumber: string, remarks?: string | null } };

export type SearchBankAccountsQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
}>;


export type SearchBankAccountsQuery = { __typename?: 'Query', searchBankAccounts: Array<{ __typename?: 'BankAccountPresenter', accountHolderName: string, accountNumber: string, accountType: string, bankName: string, branchName: string, id: string, remarks?: string | null }> };

export type GetBankAccountQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBankAccountQuery = { __typename?: 'Query', getBankAccount: { __typename?: 'BankAccountPresenter', accountHolderName: string, accountNumber: string, accountType: string, bankName: string, branchName: string, id: string, remarks?: string | null } };

export type CreateBankAccountMutationVariables = Exact<{
  input: CreateBankAccountInput;
}>;


export type CreateBankAccountMutation = { __typename?: 'Mutation', createBankAccount: { __typename?: 'BankAccountPresenter', accountHolderName: string, accountNumber: string, accountType: string, bankName: string, branchName: string, id: string, remarks?: string | null } };

export type UpdateBankAccountMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: CreateBankAccountInput;
}>;


export type UpdateBankAccountMutation = { __typename?: 'Mutation', updateBankAccount: { __typename?: 'BankAccountPresenter', accountHolderName: string, accountNumber: string, accountType: string, bankName: string, branchName: string, id: string, remarks?: string | null } };

export type CreateRealEstateBrokerMutationVariables = Exact<{
  input: CreateRealEstateBrokerInput;
}>;


export type CreateRealEstateBrokerMutation = { __typename?: 'Mutation', createRealEstateBroker: { __typename?: 'RealEstateBrokerPresenter', id: string, licenseNumber: string, mainOfficeAddress: string, name: string, phoneNumber: string, representativeName: string } };

export type CreateRealEstateTransactionSpecialistMutationVariables = Exact<{
  input: CreateRealEstateTransactionSpecialistInput;
}>;


export type CreateRealEstateTransactionSpecialistMutation = { __typename?: 'Mutation', createRealEstateTransactionSpecialist: { __typename?: 'RealEstateTransactionSpecialistPresenter', id: string, name: string, officeAddress: string, officeName: string, phoneNumber: string, registrationNumber: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } | null };

export type SearchUsersQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null }> };

export type UserFragmentFragment = { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null };

export type GetZyusetuByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetZyusetuByIdQuery = { __typename?: 'Query', getZyusetuById?: { __typename?: 'ZyusetuPresenter', id: string, title?: string | null, createdAt: any, approvalStatus: ApprovalStatus, approvalFlowId?: string | null, user?: { __typename?: 'UserPresenter', id: string, name: string } | null, approvalFlow?: { __typename?: 'ApprovalFlowPresenter', description?: string | null, id: string, name: string, steps: Array<{ __typename?: 'ApprovalStepPresenter', description?: string | null, id: string, name: string, approverId: string, stepOrder: number, stepExecution: Array<{ __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }>, approver: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }> } | null, files: Array<{ __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null }>, template: { __typename?: 'ZyusetuTemplatePresenter', id: string, title: string, description?: string | null, type: ZyusetuType, rentType?: RentType | null, rentGuaranteeType?: RentGuaranteeType | null, requiredFileTypes: Array<FileType>, optionalFileTypes: Array<FileType>, sections: Array<{ __typename?: 'ZyusetuFieldSectionPresenter', id: string, title: string, description?: string | null, index: number, keys: Array<{ __typename?: 'ZyusetuFieldKeyPresenter', id: string, keyName: string, label: string, isRequired: boolean, description?: string | null, keyStyle: {
          grid?: number;
          index: number;
          lines?: number;
          prefix?: string;
          suffix?: string;
          thousandSeparator?: boolean;
          isHidden?: boolean;
          pattern?: string;
          defaultValue?: FieldValueType;
          fieldLabel?: string;
          calculator?: string
          calculatorRelatedKeys?: string[]
          availableIf?: {
            keyName: string;
            value: FieldValueType[] | FieldValueType;
          }[];
          isSpace?: boolean;
          specialFunctionName?:
            | "isInDisasterProneDevelopedResidentialArea"
            | "isInSedimentDisasterAlertAreas"
            | "isInTsunamiDisasterAlertAreas"
            | "isInFloodArea"
            | "isInNaisuiArea"
            | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
        }
        , generator?: GenerateZyusetuContentType | null, keyType: ZyusetuFieldKeyType, items?: Array<string> | null, defaultValue?: Array<{ __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType }> | null, analyzedPayloads?: Array<{ __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any }> | null, value?: { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null } | null, changedValues?: Array<{ __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null }> | null, valueTemplate: Array<{ __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null }> }> }> }, realEstateTransactionSpecialists: Array<{ __typename?: 'RealEstateTransactionSpecialistPresenter', id: string, name: string, officeAddress: string, officeName: string, phoneNumber: string, registrationNumber: string }>, realEstateBrokers: Array<{ __typename?: 'RealEstateBrokerPresenter', id: string, licenseNumber: string, mainOfficeAddress: string, name: string, phoneNumber: string, representativeName: string }> } | null };

export type SearchZyusetuTemplateQueryVariables = Exact<{
  zyusetuType: ZyusetuType;
  rentGuaranteeType?: InputMaybe<RentGuaranteeType>;
  rentType?: InputMaybe<RentType>;
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchZyusetuTemplateQuery = { __typename?: 'Query', searchZyusetuTemplates: Array<{ __typename?: 'ZyusetuTemplatePresenter', id: string, title: string, description?: string | null, type: ZyusetuType, rentType?: RentType | null, rentGuaranteeType?: RentGuaranteeType | null, requiredFileTypes: Array<FileType>, optionalFileTypes: Array<FileType>, sections: Array<{ __typename?: 'ZyusetuFieldSectionPresenter', id: string, title: string, description?: string | null, index: number, keys: Array<{ __typename?: 'ZyusetuFieldKeyPresenter', id: string, keyName: string, label: string, isRequired: boolean, description?: string | null, keyStyle: {
        grid?: number;
        index: number;
        lines?: number;
        prefix?: string;
        suffix?: string;
        thousandSeparator?: boolean;
        isHidden?: boolean;
        pattern?: string;
        defaultValue?: FieldValueType;
        fieldLabel?: string;
        calculator?: string
        calculatorRelatedKeys?: string[]
        availableIf?: {
          keyName: string;
          value: FieldValueType[] | FieldValueType;
        }[];
        isSpace?: boolean;
        specialFunctionName?:
          | "isInDisasterProneDevelopedResidentialArea"
          | "isInSedimentDisasterAlertAreas"
          | "isInTsunamiDisasterAlertAreas"
          | "isInFloodArea"
          | "isInNaisuiArea"
          | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
      }
      , generator?: GenerateZyusetuContentType | null, keyType: ZyusetuFieldKeyType, items?: Array<string> | null, defaultValue?: Array<{ __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType }> | null, analyzedPayloads?: Array<{ __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any }> | null, value?: { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null } | null, changedValues?: Array<{ __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null }> | null, valueTemplate: Array<{ __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null }> }> }> }> };

export type CreateZyusetuMutationVariables = Exact<{
  fileIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
  title: Scalars['String']['input'];
}>;


export type CreateZyusetuMutation = { __typename?: 'Mutation', createZyusetu?: { __typename?: 'ZyusetuPresenter', id: string, title?: string | null, createdAt: any, approvalStatus: ApprovalStatus, approvalFlowId?: string | null, user?: { __typename?: 'UserPresenter', id: string, name: string } | null, approvalFlow?: { __typename?: 'ApprovalFlowPresenter', description?: string | null, id: string, name: string, steps: Array<{ __typename?: 'ApprovalStepPresenter', description?: string | null, id: string, name: string, approverId: string, stepOrder: number, stepExecution: Array<{ __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }>, approver: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }> } | null, files: Array<{ __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null }>, template: { __typename?: 'ZyusetuTemplatePresenter', id: string, title: string, description?: string | null, type: ZyusetuType, rentType?: RentType | null, rentGuaranteeType?: RentGuaranteeType | null, requiredFileTypes: Array<FileType>, optionalFileTypes: Array<FileType>, sections: Array<{ __typename?: 'ZyusetuFieldSectionPresenter', id: string, title: string, description?: string | null, index: number, keys: Array<{ __typename?: 'ZyusetuFieldKeyPresenter', id: string, keyName: string, label: string, isRequired: boolean, description?: string | null, keyStyle: {
          grid?: number;
          index: number;
          lines?: number;
          prefix?: string;
          suffix?: string;
          thousandSeparator?: boolean;
          isHidden?: boolean;
          pattern?: string;
          defaultValue?: FieldValueType;
          fieldLabel?: string;
          calculator?: string
          calculatorRelatedKeys?: string[]
          availableIf?: {
            keyName: string;
            value: FieldValueType[] | FieldValueType;
          }[];
          isSpace?: boolean;
          specialFunctionName?:
            | "isInDisasterProneDevelopedResidentialArea"
            | "isInSedimentDisasterAlertAreas"
            | "isInTsunamiDisasterAlertAreas"
            | "isInFloodArea"
            | "isInNaisuiArea"
            | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
        }
        , generator?: GenerateZyusetuContentType | null, keyType: ZyusetuFieldKeyType, items?: Array<string> | null, defaultValue?: Array<{ __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType }> | null, analyzedPayloads?: Array<{ __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any }> | null, value?: { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null } | null, changedValues?: Array<{ __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null }> | null, valueTemplate: Array<{ __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null }> }> }> }, realEstateTransactionSpecialists: Array<{ __typename?: 'RealEstateTransactionSpecialistPresenter', id: string, name: string, officeAddress: string, officeName: string, phoneNumber: string, registrationNumber: string }>, realEstateBrokers: Array<{ __typename?: 'RealEstateBrokerPresenter', id: string, licenseNumber: string, mainOfficeAddress: string, name: string, phoneNumber: string, representativeName: string }> } | null };

export type AnalyzeZyusetuFilesMutationVariables = Exact<{
  fileIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  zyusetuId: Scalars['String']['input'];
}>;


export type AnalyzeZyusetuFilesMutation = { __typename?: 'Mutation', analyzeZyusetuFiles?: { __typename?: 'ZyusetuPresenter', id: string, title?: string | null, createdAt: any, approvalStatus: ApprovalStatus, approvalFlowId?: string | null, user?: { __typename?: 'UserPresenter', id: string, name: string } | null, approvalFlow?: { __typename?: 'ApprovalFlowPresenter', description?: string | null, id: string, name: string, steps: Array<{ __typename?: 'ApprovalStepPresenter', description?: string | null, id: string, name: string, approverId: string, stepOrder: number, stepExecution: Array<{ __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }>, approver: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }> } | null, files: Array<{ __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null }>, template: { __typename?: 'ZyusetuTemplatePresenter', id: string, title: string, description?: string | null, type: ZyusetuType, rentType?: RentType | null, rentGuaranteeType?: RentGuaranteeType | null, requiredFileTypes: Array<FileType>, optionalFileTypes: Array<FileType>, sections: Array<{ __typename?: 'ZyusetuFieldSectionPresenter', id: string, title: string, description?: string | null, index: number, keys: Array<{ __typename?: 'ZyusetuFieldKeyPresenter', id: string, keyName: string, label: string, isRequired: boolean, description?: string | null, keyStyle: {
          grid?: number;
          index: number;
          lines?: number;
          prefix?: string;
          suffix?: string;
          thousandSeparator?: boolean;
          isHidden?: boolean;
          pattern?: string;
          defaultValue?: FieldValueType;
          fieldLabel?: string;
          calculator?: string
          calculatorRelatedKeys?: string[]
          availableIf?: {
            keyName: string;
            value: FieldValueType[] | FieldValueType;
          }[];
          isSpace?: boolean;
          specialFunctionName?:
            | "isInDisasterProneDevelopedResidentialArea"
            | "isInSedimentDisasterAlertAreas"
            | "isInTsunamiDisasterAlertAreas"
            | "isInFloodArea"
            | "isInNaisuiArea"
            | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
        }
        , generator?: GenerateZyusetuContentType | null, keyType: ZyusetuFieldKeyType, items?: Array<string> | null, defaultValue?: Array<{ __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType }> | null, analyzedPayloads?: Array<{ __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any }> | null, value?: { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null } | null, changedValues?: Array<{ __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null }> | null, valueTemplate: Array<{ __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null }> }> }> }, realEstateTransactionSpecialists: Array<{ __typename?: 'RealEstateTransactionSpecialistPresenter', id: string, name: string, officeAddress: string, officeName: string, phoneNumber: string, registrationNumber: string }>, realEstateBrokers: Array<{ __typename?: 'RealEstateBrokerPresenter', id: string, licenseNumber: string, mainOfficeAddress: string, name: string, phoneNumber: string, representativeName: string }> } | null };

export type UpdateZyusetuValueMutationVariables = Exact<{
  zyusetuId: Scalars['String']['input'];
  fieldId: Scalars['String']['input'];
  value: Scalars['FieldValueType']['input'];
  payloadId?: InputMaybe<Scalars['String']['input']>;
  templateDescription?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateZyusetuValueMutation = { __typename?: 'Mutation', updateZyusetuValue: boolean };

export type VerifyZyusetuValueMutationVariables = Exact<{
  zyusetuId: Scalars['String']['input'];
  input: Array<VerifyZyusetuValueInput> | VerifyZyusetuValueInput;
}>;


export type VerifyZyusetuValueMutation = { __typename?: 'Mutation', verifyZyusetuValue?: { __typename?: 'ZyusetuPresenter', id: string, title?: string | null, createdAt: any, approvalStatus: ApprovalStatus, approvalFlowId?: string | null, user?: { __typename?: 'UserPresenter', id: string, name: string } | null, approvalFlow?: { __typename?: 'ApprovalFlowPresenter', description?: string | null, id: string, name: string, steps: Array<{ __typename?: 'ApprovalStepPresenter', description?: string | null, id: string, name: string, approverId: string, stepOrder: number, stepExecution: Array<{ __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }>, approver: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }> } | null, files: Array<{ __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null }>, template: { __typename?: 'ZyusetuTemplatePresenter', id: string, title: string, description?: string | null, type: ZyusetuType, rentType?: RentType | null, rentGuaranteeType?: RentGuaranteeType | null, requiredFileTypes: Array<FileType>, optionalFileTypes: Array<FileType>, sections: Array<{ __typename?: 'ZyusetuFieldSectionPresenter', id: string, title: string, description?: string | null, index: number, keys: Array<{ __typename?: 'ZyusetuFieldKeyPresenter', id: string, keyName: string, label: string, isRequired: boolean, description?: string | null, keyStyle: {
          grid?: number;
          index: number;
          lines?: number;
          prefix?: string;
          suffix?: string;
          thousandSeparator?: boolean;
          isHidden?: boolean;
          pattern?: string;
          defaultValue?: FieldValueType;
          fieldLabel?: string;
          calculator?: string
          calculatorRelatedKeys?: string[]
          availableIf?: {
            keyName: string;
            value: FieldValueType[] | FieldValueType;
          }[];
          isSpace?: boolean;
          specialFunctionName?:
            | "isInDisasterProneDevelopedResidentialArea"
            | "isInSedimentDisasterAlertAreas"
            | "isInTsunamiDisasterAlertAreas"
            | "isInFloodArea"
            | "isInNaisuiArea"
            | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
        }
        , generator?: GenerateZyusetuContentType | null, keyType: ZyusetuFieldKeyType, items?: Array<string> | null, defaultValue?: Array<{ __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType }> | null, analyzedPayloads?: Array<{ __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any }> | null, value?: { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null } | null, changedValues?: Array<{ __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null }> | null, valueTemplate: Array<{ __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null }> }> }> }, realEstateTransactionSpecialists: Array<{ __typename?: 'RealEstateTransactionSpecialistPresenter', id: string, name: string, officeAddress: string, officeName: string, phoneNumber: string, registrationNumber: string }>, realEstateBrokers: Array<{ __typename?: 'RealEstateBrokerPresenter', id: string, licenseNumber: string, mainOfficeAddress: string, name: string, phoneNumber: string, representativeName: string }> } | null };

export type CreateZyusetuDocumentMutationVariables = Exact<{
  zyusetuId: Scalars['String']['input'];
}>;


export type CreateZyusetuDocumentMutation = { __typename?: 'Mutation', createZyusetuDocument?: { __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null } | null };

export type SetRealEstateBrokerToZyusetuMutationVariables = Exact<{
  zyusetuId: Scalars['String']['input'];
  brokerIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SetRealEstateBrokerToZyusetuMutation = { __typename?: 'Mutation', setRealEstateBrokerToZyusetu: boolean };

export type SetRealEstateTransactionSpecialistToZyusetuMutationVariables = Exact<{
  zyusetuId: Scalars['String']['input'];
  specialistIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SetRealEstateTransactionSpecialistToZyusetuMutation = { __typename?: 'Mutation', setRealEstateTransactionSpecialistToZyusetu: boolean };

export type ZyusetuFieldValueAnalyzedPayloadFragmentFragment = { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any };

export type ZyusetuFieldChangedValueFragmentFragment = { __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null };

export type ZyusetuFieldValueFragmentFragment = { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null };

export type ZyusetuFieldKeyValueTemplateFragmentFragment = { __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null };

export type ZyusetuFieldDefaultValueFragmentFragment = { __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType };

export type ZyusetuFieldKeyFragmentFragment = { __typename?: 'ZyusetuFieldKeyPresenter', id: string, keyName: string, label: string, isRequired: boolean, description?: string | null, keyStyle: {
  grid?: number;
  index: number;
  lines?: number;
  prefix?: string;
  suffix?: string;
  thousandSeparator?: boolean;
  isHidden?: boolean;
  pattern?: string;
  defaultValue?: FieldValueType;
  fieldLabel?: string;
  calculator?: string
  calculatorRelatedKeys?: string[]
  availableIf?: {
    keyName: string;
    value: FieldValueType[] | FieldValueType;
  }[];
  isSpace?: boolean;
  specialFunctionName?:
    | "isInDisasterProneDevelopedResidentialArea"
    | "isInSedimentDisasterAlertAreas"
    | "isInTsunamiDisasterAlertAreas"
    | "isInFloodArea"
    | "isInNaisuiArea"
    | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
}
, generator?: GenerateZyusetuContentType | null, keyType: ZyusetuFieldKeyType, items?: Array<string> | null, defaultValue?: Array<{ __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType }> | null, analyzedPayloads?: Array<{ __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any }> | null, value?: { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null } | null, changedValues?: Array<{ __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null }> | null, valueTemplate: Array<{ __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null }> };

export type ZyusetuFieldSectionFragmentFragment = { __typename?: 'ZyusetuFieldSectionPresenter', id: string, title: string, description?: string | null, index: number, keys: Array<{ __typename?: 'ZyusetuFieldKeyPresenter', id: string, keyName: string, label: string, isRequired: boolean, description?: string | null, keyStyle: {
    grid?: number;
    index: number;
    lines?: number;
    prefix?: string;
    suffix?: string;
    thousandSeparator?: boolean;
    isHidden?: boolean;
    pattern?: string;
    defaultValue?: FieldValueType;
    fieldLabel?: string;
    calculator?: string
    calculatorRelatedKeys?: string[]
    availableIf?: {
      keyName: string;
      value: FieldValueType[] | FieldValueType;
    }[];
    isSpace?: boolean;
    specialFunctionName?:
      | "isInDisasterProneDevelopedResidentialArea"
      | "isInSedimentDisasterAlertAreas"
      | "isInTsunamiDisasterAlertAreas"
      | "isInFloodArea"
      | "isInNaisuiArea"
      | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
  }
  , generator?: GenerateZyusetuContentType | null, keyType: ZyusetuFieldKeyType, items?: Array<string> | null, defaultValue?: Array<{ __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType }> | null, analyzedPayloads?: Array<{ __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any }> | null, value?: { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null } | null, changedValues?: Array<{ __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null }> | null, valueTemplate: Array<{ __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null }> }> };

export type ZyusetuTemplateFragmentFragment = { __typename?: 'ZyusetuTemplatePresenter', id: string, title: string, description?: string | null, type: ZyusetuType, rentType?: RentType | null, rentGuaranteeType?: RentGuaranteeType | null, requiredFileTypes: Array<FileType>, optionalFileTypes: Array<FileType>, sections: Array<{ __typename?: 'ZyusetuFieldSectionPresenter', id: string, title: string, description?: string | null, index: number, keys: Array<{ __typename?: 'ZyusetuFieldKeyPresenter', id: string, keyName: string, label: string, isRequired: boolean, description?: string | null, keyStyle: {
      grid?: number;
      index: number;
      lines?: number;
      prefix?: string;
      suffix?: string;
      thousandSeparator?: boolean;
      isHidden?: boolean;
      pattern?: string;
      defaultValue?: FieldValueType;
      fieldLabel?: string;
      calculator?: string
      calculatorRelatedKeys?: string[]
      availableIf?: {
        keyName: string;
        value: FieldValueType[] | FieldValueType;
      }[];
      isSpace?: boolean;
      specialFunctionName?:
        | "isInDisasterProneDevelopedResidentialArea"
        | "isInSedimentDisasterAlertAreas"
        | "isInTsunamiDisasterAlertAreas"
        | "isInFloodArea"
        | "isInNaisuiArea"
        | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
    }
    , generator?: GenerateZyusetuContentType | null, keyType: ZyusetuFieldKeyType, items?: Array<string> | null, defaultValue?: Array<{ __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType }> | null, analyzedPayloads?: Array<{ __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any }> | null, value?: { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null } | null, changedValues?: Array<{ __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null }> | null, valueTemplate: Array<{ __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null }> }> }> };

export type ZyusetuFragmentFragment = { __typename?: 'ZyusetuPresenter', id: string, title?: string | null, createdAt: any, approvalStatus: ApprovalStatus, approvalFlowId?: string | null, user?: { __typename?: 'UserPresenter', id: string, name: string } | null, approvalFlow?: { __typename?: 'ApprovalFlowPresenter', description?: string | null, id: string, name: string, steps: Array<{ __typename?: 'ApprovalStepPresenter', description?: string | null, id: string, name: string, approverId: string, stepOrder: number, stepExecution: Array<{ __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }>, approver: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } }> } | null, files: Array<{ __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null }>, template: { __typename?: 'ZyusetuTemplatePresenter', id: string, title: string, description?: string | null, type: ZyusetuType, rentType?: RentType | null, rentGuaranteeType?: RentGuaranteeType | null, requiredFileTypes: Array<FileType>, optionalFileTypes: Array<FileType>, sections: Array<{ __typename?: 'ZyusetuFieldSectionPresenter', id: string, title: string, description?: string | null, index: number, keys: Array<{ __typename?: 'ZyusetuFieldKeyPresenter', id: string, keyName: string, label: string, isRequired: boolean, description?: string | null, keyStyle: {
        grid?: number;
        index: number;
        lines?: number;
        prefix?: string;
        suffix?: string;
        thousandSeparator?: boolean;
        isHidden?: boolean;
        pattern?: string;
        defaultValue?: FieldValueType;
        fieldLabel?: string;
        calculator?: string
        calculatorRelatedKeys?: string[]
        availableIf?: {
          keyName: string;
          value: FieldValueType[] | FieldValueType;
        }[];
        isSpace?: boolean;
        specialFunctionName?:
          | "isInDisasterProneDevelopedResidentialArea"
          | "isInSedimentDisasterAlertAreas"
          | "isInTsunamiDisasterAlertAreas"
          | "isInFloodArea"
          | "isInNaisuiArea"
          | "isInHightideArea" | "cityPlanningRestrictions" | "floorAreaCalculator";
      }
      , generator?: GenerateZyusetuContentType | null, keyType: ZyusetuFieldKeyType, items?: Array<string> | null, defaultValue?: Array<{ __typename?: 'ZyusetuFieldDefaultValuePresenter', id: string, value: FieldValueType }> | null, analyzedPayloads?: Array<{ __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any }> | null, value?: { __typename?: 'ZyusetuFieldValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null } | null, changedValues?: Array<{ __typename?: 'ZyusetuFieldChangedValuePresenter', id: string, value?: FieldValueType | null, isVerified: boolean, createdAt: any, templateDescription?: string | null, approvalStepExecutionId: string, selectedPayload?: { __typename?: 'ZyusetuFieldValueAnalyzedPayloadPresenter', id: string, type: AnalyzerType, normalizedContent?: FieldValueType | null, content?: FieldValueType | null, azureFieldType?: DocumentFieldTypeOutput | null, azureFieldOutput?: any | null, boundingRegions?: any | null, confidence?: number | null, properties?: any | null, pageAnchor?: any | null, analyzedFileId?: string | null, createdAt: any } | null }> | null, valueTemplate: Array<{ __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null }> }> }> }, realEstateTransactionSpecialists: Array<{ __typename?: 'RealEstateTransactionSpecialistPresenter', id: string, name: string, officeAddress: string, officeName: string, phoneNumber: string, registrationNumber: string }>, realEstateBrokers: Array<{ __typename?: 'RealEstateBrokerPresenter', id: string, licenseNumber: string, mainOfficeAddress: string, name: string, phoneNumber: string, representativeName: string }> };

export type GetZyusetuSimpleQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  search?: InputMaybe<ZyusetuSearchInput>;
}>;


export type GetZyusetuSimpleQuery = { __typename?: 'Query', getZyusetuSimple?: { __typename?: 'PaginatedZyusetuSimplePresenter', total: number, items: Array<{ __typename?: 'ZyusetuSimplePresenter', createdAt: any, id: string, approvalStatus: ApprovalStatus, templateTitle: string, approvalStepExecutionId?: string | null, title?: string | null, userId?: string | null, files: Array<{ __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null }>, approvalStepExecution?: { __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } } | null, user?: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } | null }> } | null };

export type ZyusetuSimpleFragmentFragment = { __typename?: 'ZyusetuSimplePresenter', createdAt: any, id: string, approvalStatus: ApprovalStatus, templateTitle: string, approvalStepExecutionId?: string | null, title?: string | null, userId?: string | null, files: Array<{ __typename?: 'FilePresenter', analyzeStatus: FileAnalyzeStatus, azureAnalyzeResult?: AnalyzeResultOperationOutput | null, pageData?: any | null, createdAt: any, fileName: string, fileType: FileType, id: string, mimeType: string, text?: string | null, title: string, url?: string | null, handRotation?: number | null }>, approvalStepExecution?: { __typename?: 'ApprovalStepExecutionPresenter', comment?: string | null, id: string, status: ApprovalStepStatus, userId: string, user: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } } | null, user?: { __typename?: 'UserPresenter', email: string, id: string, name: string, createdAt: string, organizationId: string, isDeleted: boolean, organization?: { __typename?: 'OrganizationPresenter', id: string, name: string, createdAt: any, useApprovalFlow: boolean, defaultApprovalFlowId?: string | null, usage?: { __typename?: 'OrganizationUsagePresenter', id: string, managementByRawAnalyzeCount: number, month: string, zumenAnalyzeCount: number, zyusetuCount: number } | null, usageLimit?: { __typename?: 'OrganizationUsageLimitPresenter', id: string, managementByRawAnalyzeCount: number, zumenAnalyzeCount: number, zyusetuCount: number, plan: UsagePlanType } | null } | null } | null };

export type UpdateZyusetuDefaultValueMutationVariables = Exact<{
  keyId: Scalars['String']['input'];
  value: Scalars['FieldValueType']['input'];
  zyusetuDefaultValueId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateZyusetuDefaultValueMutation = { __typename?: 'Mutation', updateZyusetuDefaultValue: string };

export type DeleteZyusetuDefaultValueMutationVariables = Exact<{
  zyusetuDefaultValueId: Scalars['String']['input'];
}>;


export type DeleteZyusetuDefaultValueMutation = { __typename?: 'Mutation', deleteZyusetuDefaultValue: boolean };

export type CreateZyusetuValueTemplateMutationVariables = Exact<{
  keyId: Scalars['String']['input'];
  input: CreateZyusetuValueTemplateInput;
}>;


export type CreateZyusetuValueTemplateMutation = { __typename?: 'Mutation', createZyusetuValueTemplate: { __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null } };

export type UpdateZyusetuValueTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: CreateZyusetuValueTemplateInput;
}>;


export type UpdateZyusetuValueTemplateMutation = { __typename?: 'Mutation', updateZyusetuValueTemplate: { __typename?: 'ZyusetuFieldKeyValueTemplatePresenter', id: string, value: FieldValueType, description?: string | null } };

export type DeleteZyusetuValueTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteZyusetuValueTemplateMutation = { __typename?: 'Mutation', deleteZyusetuValueTemplate: boolean };


export const ApprovalStepFieldsFragmentDoc = `
    fragment ApprovalStepFields on ApprovalStepPresenter {
  id
  name
  description
  stepOrder
  approverId
  isDeleted
  approver {
    id
    name
    email
    organizationId
  }
}
    `;
export const ApprovalFlowFieldsFragmentDoc = `
    fragment ApprovalFlowFields on ApprovalFlowPresenter {
  id
  name
  description
  isDeleted
  steps {
    ...ApprovalStepFields
  }
}
    `;
export const UserAdminFieldsFragmentDoc = `
    fragment UserAdminFields on UserAdminPresenter {
  id
  name
  email
  roles
  auth0Id
  organizationId
  isDeleted
  createdAt
  organization {
    id
    name
    useApprovalFlow
    defaultApprovalFlowId
  }
  defaultApprovalFlowId
  defaultApprovalFlow {
    ...ApprovalFlowFields
  }
}
    `;
export const AddressInfoFragmentFragmentDoc = `
    fragment AddressInfoFragment on AddressInfo {
  lat
  lng
  x
  y
  zoom
  isInDisasteProneDevelopedResidentialArea
  hazardMapLinks {
    url
    type
  }
}
    `;
export const ManagementCompanyFragmentFragmentDoc = `
    fragment ManagementCompanyFragment on ManagementCompanyPresenter {
  id
  name
  address
  phoneNumber
  registrationNumber
  remarks
}
    `;
export const BankAccountFragmentFragmentDoc = `
    fragment BankAccountFragment on BankAccountPresenter {
  accountHolderName
  accountNumber
  accountType
  bankName
  branchName
  id
  remarks
}
    `;
export const OrganizationUsageFragmentFragmentDoc = `
    fragment OrganizationUsageFragment on OrganizationUsagePresenter {
  id
  managementByRawAnalyzeCount
  month
  zumenAnalyzeCount
  zyusetuCount
}
    `;
export const OrganizationUsageLimitFragmentFragmentDoc = `
    fragment OrganizationUsageLimitFragment on OrganizationUsageLimitPresenter {
  id
  managementByRawAnalyzeCount
  zumenAnalyzeCount
  zyusetuCount
  plan
}
    `;
export const OrganizationFragmentFragmentDoc = `
    fragment OrganizationFragment on OrganizationPresenter {
  id
  name
  createdAt
  useApprovalFlow
  defaultApprovalFlowId
  usage {
    ...OrganizationUsageFragment
  }
  usageLimit {
    ...OrganizationUsageLimitFragment
  }
}
    `;
export const UserFragmentFragmentDoc = `
    fragment UserFragment on UserPresenter {
  email
  id
  name
  createdAt
  organizationId
  isDeleted
  organizationId
  organization {
    ...OrganizationFragment
  }
}
    `;
export const ApprovalStepExecutionFragmentFragmentDoc = `
    fragment ApprovalStepExecutionFragment on ApprovalStepExecutionPresenter {
  comment
  id
  status
  user {
    ...UserFragment
  }
  userId
}
    `;
export const ApprovalStepFragmentFragmentDoc = `
    fragment ApprovalStepFragment on ApprovalStepPresenter {
  description
  id
  name
  approverId
  stepExecution {
    ...ApprovalStepExecutionFragment
  }
  approver {
    ...UserFragment
  }
  stepOrder
}
    `;
export const ApprovalFlowFragmentFragmentDoc = `
    fragment ApprovalFlowFragment on ApprovalFlowPresenter {
  description
  id
  name
  steps {
    ...ApprovalStepFragment
  }
}
    `;
export const FileFragmentFragmentDoc = `
    fragment FileFragment on FilePresenter {
  analyzeStatus
  azureAnalyzeResult
  pageData
  createdAt
  fileName
  fileType
  id
  mimeType
  text
  title
  url
  handRotation
}
    `;
export const ZyusetuFieldDefaultValueFragmentFragmentDoc = `
    fragment ZyusetuFieldDefaultValueFragment on ZyusetuFieldDefaultValuePresenter {
  id
  value
}
    `;
export const ZyusetuFieldValueAnalyzedPayloadFragmentFragmentDoc = `
    fragment ZyusetuFieldValueAnalyzedPayloadFragment on ZyusetuFieldValueAnalyzedPayloadPresenter {
  id
  type
  normalizedContent
  content
  azureFieldType
  azureFieldOutput
  boundingRegions
  boundingRegions
  confidence
  properties
  pageAnchor
  analyzedFileId
  createdAt
}
    `;
export const ZyusetuFieldValueFragmentFragmentDoc = `
    fragment ZyusetuFieldValueFragment on ZyusetuFieldValuePresenter {
  id
  value
  isVerified
  createdAt
  templateDescription
  selectedPayload {
    ...ZyusetuFieldValueAnalyzedPayloadFragment
  }
}
    `;
export const ZyusetuFieldChangedValueFragmentFragmentDoc = `
    fragment ZyusetuFieldChangedValueFragment on ZyusetuFieldChangedValuePresenter {
  id
  value
  isVerified
  createdAt
  templateDescription
  approvalStepExecutionId
  selectedPayload {
    ...ZyusetuFieldValueAnalyzedPayloadFragment
  }
}
    `;
export const ZyusetuFieldKeyValueTemplateFragmentFragmentDoc = `
    fragment ZyusetuFieldKeyValueTemplateFragment on ZyusetuFieldKeyValueTemplatePresenter {
  id
  value
  description
}
    `;
export const ZyusetuFieldKeyFragmentFragmentDoc = `
    fragment ZyusetuFieldKeyFragment on ZyusetuFieldKeyPresenter {
  id
  keyName
  label
  isRequired
  description
  keyStyle
  generator
  keyType
  items
  defaultValue {
    ...ZyusetuFieldDefaultValueFragment
  }
  analyzedPayloads {
    ...ZyusetuFieldValueAnalyzedPayloadFragment
  }
  value {
    ...ZyusetuFieldValueFragment
  }
  changedValues {
    ...ZyusetuFieldChangedValueFragment
  }
  valueTemplate {
    ...ZyusetuFieldKeyValueTemplateFragment
  }
}
    `;
export const ZyusetuFieldSectionFragmentFragmentDoc = `
    fragment ZyusetuFieldSectionFragment on ZyusetuFieldSectionPresenter {
  id
  title
  description
  index
  keys {
    ...ZyusetuFieldKeyFragment
  }
}
    `;
export const ZyusetuTemplateFragmentFragmentDoc = `
    fragment ZyusetuTemplateFragment on ZyusetuTemplatePresenter {
  id
  title
  description
  type
  rentType
  rentGuaranteeType
  requiredFileTypes
  optionalFileTypes
  sections {
    ...ZyusetuFieldSectionFragment
  }
}
    `;
export const RealEstateTransactionSpecialistFragmentFragmentDoc = `
    fragment RealEstateTransactionSpecialistFragment on RealEstateTransactionSpecialistPresenter {
  id
  name
  officeAddress
  officeName
  phoneNumber
  registrationNumber
}
    `;
export const RealEstateBrokerFragmentFragmentDoc = `
    fragment RealEstateBrokerFragment on RealEstateBrokerPresenter {
  id
  licenseNumber
  mainOfficeAddress
  name
  phoneNumber
  representativeName
}
    `;
export const ZyusetuFragmentFragmentDoc = `
    fragment ZyusetuFragment on ZyusetuPresenter {
  id
  title
  createdAt
  approvalStatus
  approvalFlowId
  user {
    id
    name
  }
  approvalFlow {
    ...ApprovalFlowFragment
  }
  files {
    ...FileFragment
  }
  template {
    ...ZyusetuTemplateFragment
  }
  realEstateTransactionSpecialists {
    ...RealEstateTransactionSpecialistFragment
  }
  realEstateBrokers {
    ...RealEstateBrokerFragment
  }
}
    `;
export const ZyusetuSimpleFragmentFragmentDoc = `
    fragment ZyusetuSimpleFragment on ZyusetuSimplePresenter {
  createdAt
  files {
    ...FileFragment
  }
  id
  approvalStatus
  templateTitle
  approvalStepExecutionId
  approvalStepExecution {
    ...ApprovalStepExecutionFragment
  }
  title
  userId
  user {
    ...UserFragment
  }
}
    `;
export const ListUsersDocument = `
    query ListUsers {
  listUsers {
    ...UserAdminFields
  }
}
    ${UserAdminFieldsFragmentDoc}
${ApprovalFlowFieldsFragmentDoc}
${ApprovalStepFieldsFragmentDoc}`;

export const useListUsersQuery = <
      TData = ListUsersQuery,
      TError = GraphqlError
    >(
      variables?: ListUsersQueryVariables,
      options?: Omit<UseQueryOptions<ListUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListUsersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ListUsers'] : ['ListUsers', variables],
    queryFn: useFetcher<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument).bind(null, variables),
    ...options
  }
    )};

useListUsersQuery.getKey = (variables?: ListUsersQueryVariables) => variables === undefined ? ['ListUsers'] : ['ListUsers', variables];

export const GetUserDocument = `
    query GetUser($userId: String!) {
  getUser(userId: $userId) {
    ...UserAdminFields
  }
}
    ${UserAdminFieldsFragmentDoc}
${ApprovalFlowFieldsFragmentDoc}
${ApprovalStepFieldsFragmentDoc}`;

export const useGetUserQuery = <
      TData = GetUserQuery,
      TError = GraphqlError
    >(
      variables: GetUserQueryVariables,
      options?: Omit<UseQueryOptions<GetUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserQuery, TError, TData>(
      {
    queryKey: ['GetUser', variables],
    queryFn: useFetcher<GetUserQuery, GetUserQueryVariables>(GetUserDocument).bind(null, variables),
    ...options
  }
    )};

useGetUserQuery.getKey = (variables: GetUserQueryVariables) => ['GetUser', variables];

export const CreateUserDocument = `
    mutation CreateUser($email: String!, $name: String!, $password: String!, $roleIds: [String!]!) {
  createUser(email: $email, name: $name, password: $password, roleIds: $roleIds) {
    ...UserAdminFields
  }
}
    ${UserAdminFieldsFragmentDoc}
${ApprovalFlowFieldsFragmentDoc}
${ApprovalStepFieldsFragmentDoc}`;

export const useCreateUserMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUserMutation, TError, CreateUserMutationVariables, TContext>) => {
    
    return useMutation<CreateUserMutation, TError, CreateUserMutationVariables, TContext>(
      {
    mutationKey: ['CreateUser'],
    mutationFn: useFetcher<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument),
    ...options
  }
    )};

export const SetRoleDocument = `
    mutation SetRole($userId: String!, $roleIds: [String!]!) {
  setRole(userId: $userId, roleIds: $roleIds) {
    ...UserAdminFields
  }
}
    ${UserAdminFieldsFragmentDoc}
${ApprovalFlowFieldsFragmentDoc}
${ApprovalStepFieldsFragmentDoc}`;

export const useSetRoleMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<SetRoleMutation, TError, SetRoleMutationVariables, TContext>) => {
    
    return useMutation<SetRoleMutation, TError, SetRoleMutationVariables, TContext>(
      {
    mutationKey: ['SetRole'],
    mutationFn: useFetcher<SetRoleMutation, SetRoleMutationVariables>(SetRoleDocument),
    ...options
  }
    )};

export const DeleteUserDocument = `
    mutation DeleteUser($userId: String!) {
  deleteUser(userId: $userId)
}
    `;

export const useDeleteUserMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>) => {
    
    return useMutation<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>(
      {
    mutationKey: ['DeleteUser'],
    mutationFn: useFetcher<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument),
    ...options
  }
    )};

export const RestoreUserDocument = `
    mutation RestoreUser($userId: String!) {
  restoreUser(userId: $userId)
}
    `;

export const useRestoreUserMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<RestoreUserMutation, TError, RestoreUserMutationVariables, TContext>) => {
    
    return useMutation<RestoreUserMutation, TError, RestoreUserMutationVariables, TContext>(
      {
    mutationKey: ['RestoreUser'],
    mutationFn: useFetcher<RestoreUserMutation, RestoreUserMutationVariables>(RestoreUserDocument),
    ...options
  }
    )};

export const GetApprovalFlowsDocument = `
    query GetApprovalFlows {
  getApprovalFlows {
    ...ApprovalFlowFields
  }
}
    ${ApprovalFlowFieldsFragmentDoc}
${ApprovalStepFieldsFragmentDoc}`;

export const useGetApprovalFlowsQuery = <
      TData = GetApprovalFlowsQuery,
      TError = GraphqlError
    >(
      variables?: GetApprovalFlowsQueryVariables,
      options?: Omit<UseQueryOptions<GetApprovalFlowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetApprovalFlowsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetApprovalFlowsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetApprovalFlows'] : ['GetApprovalFlows', variables],
    queryFn: useFetcher<GetApprovalFlowsQuery, GetApprovalFlowsQueryVariables>(GetApprovalFlowsDocument).bind(null, variables),
    ...options
  }
    )};

useGetApprovalFlowsQuery.getKey = (variables?: GetApprovalFlowsQueryVariables) => variables === undefined ? ['GetApprovalFlows'] : ['GetApprovalFlows', variables];

export const GetApprovalFlowByIdDocument = `
    query GetApprovalFlowById($id: String!) {
  getApprovalFlowById(id: $id) {
    ...ApprovalFlowFields
  }
}
    ${ApprovalFlowFieldsFragmentDoc}
${ApprovalStepFieldsFragmentDoc}`;

export const useGetApprovalFlowByIdQuery = <
      TData = GetApprovalFlowByIdQuery,
      TError = GraphqlError
    >(
      variables: GetApprovalFlowByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetApprovalFlowByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetApprovalFlowByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetApprovalFlowByIdQuery, TError, TData>(
      {
    queryKey: ['GetApprovalFlowById', variables],
    queryFn: useFetcher<GetApprovalFlowByIdQuery, GetApprovalFlowByIdQueryVariables>(GetApprovalFlowByIdDocument).bind(null, variables),
    ...options
  }
    )};

useGetApprovalFlowByIdQuery.getKey = (variables: GetApprovalFlowByIdQueryVariables) => ['GetApprovalFlowById', variables];

export const CreateApprovalFlowDocument = `
    mutation CreateApprovalFlow($input: CreateApprovalFlowInput!) {
  createApprovalFlow(input: $input) {
    ...ApprovalFlowFields
  }
}
    ${ApprovalFlowFieldsFragmentDoc}
${ApprovalStepFieldsFragmentDoc}`;

export const useCreateApprovalFlowMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<CreateApprovalFlowMutation, TError, CreateApprovalFlowMutationVariables, TContext>) => {
    
    return useMutation<CreateApprovalFlowMutation, TError, CreateApprovalFlowMutationVariables, TContext>(
      {
    mutationKey: ['CreateApprovalFlow'],
    mutationFn: useFetcher<CreateApprovalFlowMutation, CreateApprovalFlowMutationVariables>(CreateApprovalFlowDocument),
    ...options
  }
    )};

export const UpdateApprovalFlowDocument = `
    mutation UpdateApprovalFlow($input: UpdateApprovalFlowInput!) {
  updateApprovalFlow(input: $input) {
    ...ApprovalFlowFields
  }
}
    ${ApprovalFlowFieldsFragmentDoc}
${ApprovalStepFieldsFragmentDoc}`;

export const useUpdateApprovalFlowMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateApprovalFlowMutation, TError, UpdateApprovalFlowMutationVariables, TContext>) => {
    
    return useMutation<UpdateApprovalFlowMutation, TError, UpdateApprovalFlowMutationVariables, TContext>(
      {
    mutationKey: ['UpdateApprovalFlow'],
    mutationFn: useFetcher<UpdateApprovalFlowMutation, UpdateApprovalFlowMutationVariables>(UpdateApprovalFlowDocument),
    ...options
  }
    )};

export const DeleteApprovalFlowDocument = `
    mutation DeleteApprovalFlow($id: String!) {
  deleteApprovalFlow(id: $id)
}
    `;

export const useDeleteApprovalFlowMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteApprovalFlowMutation, TError, DeleteApprovalFlowMutationVariables, TContext>) => {
    
    return useMutation<DeleteApprovalFlowMutation, TError, DeleteApprovalFlowMutationVariables, TContext>(
      {
    mutationKey: ['DeleteApprovalFlow'],
    mutationFn: useFetcher<DeleteApprovalFlowMutation, DeleteApprovalFlowMutationVariables>(DeleteApprovalFlowDocument),
    ...options
  }
    )};

export const RestoreApprovalFlowDocument = `
    mutation RestoreApprovalFlow($id: String!) {
  restoreApprovalFlow(id: $id)
}
    `;

export const useRestoreApprovalFlowMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<RestoreApprovalFlowMutation, TError, RestoreApprovalFlowMutationVariables, TContext>) => {
    
    return useMutation<RestoreApprovalFlowMutation, TError, RestoreApprovalFlowMutationVariables, TContext>(
      {
    mutationKey: ['RestoreApprovalFlow'],
    mutationFn: useFetcher<RestoreApprovalFlowMutation, RestoreApprovalFlowMutationVariables>(RestoreApprovalFlowDocument),
    ...options
  }
    )};

export const SetOrganizationDefaultApprovalFlowDocument = `
    mutation SetOrganizationDefaultApprovalFlow($id: String) {
  setOrganizationDefaultApprovalFlow(id: $id)
}
    `;

export const useSetOrganizationDefaultApprovalFlowMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<SetOrganizationDefaultApprovalFlowMutation, TError, SetOrganizationDefaultApprovalFlowMutationVariables, TContext>) => {
    
    return useMutation<SetOrganizationDefaultApprovalFlowMutation, TError, SetOrganizationDefaultApprovalFlowMutationVariables, TContext>(
      {
    mutationKey: ['SetOrganizationDefaultApprovalFlow'],
    mutationFn: useFetcher<SetOrganizationDefaultApprovalFlowMutation, SetOrganizationDefaultApprovalFlowMutationVariables>(SetOrganizationDefaultApprovalFlowDocument),
    ...options
  }
    )};

export const SetUserDefaultApprovalFlowDocument = `
    mutation SetUserDefaultApprovalFlow($userId: String!, $id: String) {
  setUserDefaultApprovalFlow(userId: $userId, id: $id)
}
    `;

export const useSetUserDefaultApprovalFlowMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<SetUserDefaultApprovalFlowMutation, TError, SetUserDefaultApprovalFlowMutationVariables, TContext>) => {
    
    return useMutation<SetUserDefaultApprovalFlowMutation, TError, SetUserDefaultApprovalFlowMutationVariables, TContext>(
      {
    mutationKey: ['SetUserDefaultApprovalFlow'],
    mutationFn: useFetcher<SetUserDefaultApprovalFlowMutation, SetUserDefaultApprovalFlowMutationVariables>(SetUserDefaultApprovalFlowDocument),
    ...options
  }
    )};

export const UpdateOrganizationApprovalFlowSettingsDocument = `
    mutation UpdateOrganizationApprovalFlowSettings($useApprovalFlow: Boolean!) {
  updateOrganizationApprovalFlowSettings(useApprovalFlow: $useApprovalFlow)
}
    `;

export const useUpdateOrganizationApprovalFlowSettingsMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOrganizationApprovalFlowSettingsMutation, TError, UpdateOrganizationApprovalFlowSettingsMutationVariables, TContext>) => {
    
    return useMutation<UpdateOrganizationApprovalFlowSettingsMutation, TError, UpdateOrganizationApprovalFlowSettingsMutationVariables, TContext>(
      {
    mutationKey: ['UpdateOrganizationApprovalFlowSettings'],
    mutationFn: useFetcher<UpdateOrganizationApprovalFlowSettingsMutation, UpdateOrganizationApprovalFlowSettingsMutationVariables>(UpdateOrganizationApprovalFlowSettingsDocument),
    ...options
  }
    )};

export const AnalyzeFileDocument = `
    mutation AnalyzeFile($fileId: String!, $zyusetuType: ZyusetuType!) {
  analyzeFile(id: $fileId, zyusetuType: $zyusetuType) {
    fields {
      ...ZyusetuFieldSectionFragment
    }
    file {
      ...FileFragment
    }
  }
}
    ${ZyusetuFieldSectionFragmentFragmentDoc}
${ZyusetuFieldKeyFragmentFragmentDoc}
${ZyusetuFieldDefaultValueFragmentFragmentDoc}
${ZyusetuFieldValueAnalyzedPayloadFragmentFragmentDoc}
${ZyusetuFieldValueFragmentFragmentDoc}
${ZyusetuFieldChangedValueFragmentFragmentDoc}
${ZyusetuFieldKeyValueTemplateFragmentFragmentDoc}
${FileFragmentFragmentDoc}`;

export const useAnalyzeFileMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<AnalyzeFileMutation, TError, AnalyzeFileMutationVariables, TContext>) => {
    
    return useMutation<AnalyzeFileMutation, TError, AnalyzeFileMutationVariables, TContext>(
      {
    mutationKey: ['AnalyzeFile'],
    mutationFn: useFetcher<AnalyzeFileMutation, AnalyzeFileMutationVariables>(AnalyzeFileDocument),
    ...options
  }
    )};

export const GetAddressInfoDocument = `
    query GetAddressInfo($address: String!) {
  getAddressInfo(address: $address) {
    ...AddressInfoFragment
  }
}
    ${AddressInfoFragmentFragmentDoc}`;

export const useGetAddressInfoQuery = <
      TData = GetAddressInfoQuery,
      TError = GraphqlError
    >(
      variables: GetAddressInfoQueryVariables,
      options?: Omit<UseQueryOptions<GetAddressInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAddressInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAddressInfoQuery, TError, TData>(
      {
    queryKey: ['GetAddressInfo', variables],
    queryFn: useFetcher<GetAddressInfoQuery, GetAddressInfoQueryVariables>(GetAddressInfoDocument).bind(null, variables),
    ...options
  }
    )};

useGetAddressInfoQuery.getKey = (variables: GetAddressInfoQueryVariables) => ['GetAddressInfo', variables];

export const GenerateZyusetuContentStringDocument = `
    mutation GenerateZyusetuContentString($content: String!, $type: GenerateZyusetuContentType!) {
  generateZyusetuContentString(content: $content, type: $type)
}
    `;

export const useGenerateZyusetuContentStringMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateZyusetuContentStringMutation, TError, GenerateZyusetuContentStringMutationVariables, TContext>) => {
    
    return useMutation<GenerateZyusetuContentStringMutation, TError, GenerateZyusetuContentStringMutationVariables, TContext>(
      {
    mutationKey: ['GenerateZyusetuContentString'],
    mutationFn: useFetcher<GenerateZyusetuContentStringMutation, GenerateZyusetuContentStringMutationVariables>(GenerateZyusetuContentStringDocument),
    ...options
  }
    )};

export const RequestApprovalDocument = `
    mutation RequestApproval($zyusetuId: String!) {
  requestApprove(zyusetuId: $zyusetuId) {
    ...ApprovalFlowFragment
  }
}
    ${ApprovalFlowFragmentFragmentDoc}
${ApprovalStepFragmentFragmentDoc}
${ApprovalStepExecutionFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${OrganizationUsageFragmentFragmentDoc}
${OrganizationUsageLimitFragmentFragmentDoc}`;

export const useRequestApprovalMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<RequestApprovalMutation, TError, RequestApprovalMutationVariables, TContext>) => {
    
    return useMutation<RequestApprovalMutation, TError, RequestApprovalMutationVariables, TContext>(
      {
    mutationKey: ['RequestApproval'],
    mutationFn: useFetcher<RequestApprovalMutation, RequestApprovalMutationVariables>(RequestApprovalDocument),
    ...options
  }
    )};

export const GetPendingReviewsDocument = `
    query GetPendingReviews($skip: Int!, $take: Int!) {
  getPendingReviews(paginate: {skip: $skip, take: $take}) {
    items {
      ...ZyusetuSimpleFragment
    }
    total
  }
}
    ${ZyusetuSimpleFragmentFragmentDoc}
${FileFragmentFragmentDoc}
${ApprovalStepExecutionFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${OrganizationUsageFragmentFragmentDoc}
${OrganizationUsageLimitFragmentFragmentDoc}`;

export const useGetPendingReviewsQuery = <
      TData = GetPendingReviewsQuery,
      TError = GraphqlError
    >(
      variables: GetPendingReviewsQueryVariables,
      options?: Omit<UseQueryOptions<GetPendingReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPendingReviewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPendingReviewsQuery, TError, TData>(
      {
    queryKey: ['GetPendingReviews', variables],
    queryFn: useFetcher<GetPendingReviewsQuery, GetPendingReviewsQueryVariables>(GetPendingReviewsDocument).bind(null, variables),
    ...options
  }
    )};

useGetPendingReviewsQuery.getKey = (variables: GetPendingReviewsQueryVariables) => ['GetPendingReviews', variables];

export const ApproveStepDocument = `
    mutation ApproveStep($stepExecutionId: String!, $result: ApprovalStepStatus!, $zyusetuId: String!, $comment: String) {
  approveStep(
    executionId: $stepExecutionId
    result: $result
    comment: $comment
    zyusetuId: $zyusetuId
  ) {
    ...ZyusetuFragment
  }
}
    ${ZyusetuFragmentFragmentDoc}
${ApprovalFlowFragmentFragmentDoc}
${ApprovalStepFragmentFragmentDoc}
${ApprovalStepExecutionFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${OrganizationUsageFragmentFragmentDoc}
${OrganizationUsageLimitFragmentFragmentDoc}
${FileFragmentFragmentDoc}
${ZyusetuTemplateFragmentFragmentDoc}
${ZyusetuFieldSectionFragmentFragmentDoc}
${ZyusetuFieldKeyFragmentFragmentDoc}
${ZyusetuFieldDefaultValueFragmentFragmentDoc}
${ZyusetuFieldValueAnalyzedPayloadFragmentFragmentDoc}
${ZyusetuFieldValueFragmentFragmentDoc}
${ZyusetuFieldChangedValueFragmentFragmentDoc}
${ZyusetuFieldKeyValueTemplateFragmentFragmentDoc}
${RealEstateTransactionSpecialistFragmentFragmentDoc}
${RealEstateBrokerFragmentFragmentDoc}`;

export const useApproveStepMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<ApproveStepMutation, TError, ApproveStepMutationVariables, TContext>) => {
    
    return useMutation<ApproveStepMutation, TError, ApproveStepMutationVariables, TContext>(
      {
    mutationKey: ['ApproveStep'],
    mutationFn: useFetcher<ApproveStepMutation, ApproveStepMutationVariables>(ApproveStepDocument),
    ...options
  }
    )};

export const UndoRequestApproveDocument = `
    mutation UndoRequestApprove($zyusetuId: String!) {
  undoRequestApprove(zyusetuId: $zyusetuId)
}
    `;

export const useUndoRequestApproveMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<UndoRequestApproveMutation, TError, UndoRequestApproveMutationVariables, TContext>) => {
    
    return useMutation<UndoRequestApproveMutation, TError, UndoRequestApproveMutationVariables, TContext>(
      {
    mutationKey: ['UndoRequestApprove'],
    mutationFn: useFetcher<UndoRequestApproveMutation, UndoRequestApproveMutationVariables>(UndoRequestApproveDocument),
    ...options
  }
    )};

export const UndoApprovedStatusDocument = `
    mutation UndoApprovedStatus($zyusetuId: String!) {
  undoApprovedStatus(zyusetuId: $zyusetuId)
}
    `;

export const useUndoApprovedStatusMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<UndoApprovedStatusMutation, TError, UndoApprovedStatusMutationVariables, TContext>) => {
    
    return useMutation<UndoApprovedStatusMutation, TError, UndoApprovedStatusMutationVariables, TContext>(
      {
    mutationKey: ['UndoApprovedStatus'],
    mutationFn: useFetcher<UndoApprovedStatusMutation, UndoApprovedStatusMutationVariables>(UndoApprovedStatusDocument),
    ...options
  }
    )};

export const GetZyusetuByApprovalExecutionIdDocument = `
    query GetZyusetuByApprovalExecutionId($executionId: String!) {
  getZyusetuByStepExecutionId(executionId: $executionId) {
    ...ZyusetuFragment
  }
}
    ${ZyusetuFragmentFragmentDoc}
${ApprovalFlowFragmentFragmentDoc}
${ApprovalStepFragmentFragmentDoc}
${ApprovalStepExecutionFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${OrganizationUsageFragmentFragmentDoc}
${OrganizationUsageLimitFragmentFragmentDoc}
${FileFragmentFragmentDoc}
${ZyusetuTemplateFragmentFragmentDoc}
${ZyusetuFieldSectionFragmentFragmentDoc}
${ZyusetuFieldKeyFragmentFragmentDoc}
${ZyusetuFieldDefaultValueFragmentFragmentDoc}
${ZyusetuFieldValueAnalyzedPayloadFragmentFragmentDoc}
${ZyusetuFieldValueFragmentFragmentDoc}
${ZyusetuFieldChangedValueFragmentFragmentDoc}
${ZyusetuFieldKeyValueTemplateFragmentFragmentDoc}
${RealEstateTransactionSpecialistFragmentFragmentDoc}
${RealEstateBrokerFragmentFragmentDoc}`;

export const useGetZyusetuByApprovalExecutionIdQuery = <
      TData = GetZyusetuByApprovalExecutionIdQuery,
      TError = GraphqlError
    >(
      variables: GetZyusetuByApprovalExecutionIdQueryVariables,
      options?: Omit<UseQueryOptions<GetZyusetuByApprovalExecutionIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetZyusetuByApprovalExecutionIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetZyusetuByApprovalExecutionIdQuery, TError, TData>(
      {
    queryKey: ['GetZyusetuByApprovalExecutionId', variables],
    queryFn: useFetcher<GetZyusetuByApprovalExecutionIdQuery, GetZyusetuByApprovalExecutionIdQueryVariables>(GetZyusetuByApprovalExecutionIdDocument).bind(null, variables),
    ...options
  }
    )};

useGetZyusetuByApprovalExecutionIdQuery.getKey = (variables: GetZyusetuByApprovalExecutionIdQueryVariables) => ['GetZyusetuByApprovalExecutionId', variables];

export const GetPendingReviewCountDocument = `
    query GetPendingReviewCount($status: ApprovalStepStatus) {
  getPendingReviewCount(status: $status)
}
    `;

export const useGetPendingReviewCountQuery = <
      TData = GetPendingReviewCountQuery,
      TError = GraphqlError
    >(
      variables?: GetPendingReviewCountQueryVariables,
      options?: Omit<UseQueryOptions<GetPendingReviewCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPendingReviewCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPendingReviewCountQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetPendingReviewCount'] : ['GetPendingReviewCount', variables],
    queryFn: useFetcher<GetPendingReviewCountQuery, GetPendingReviewCountQueryVariables>(GetPendingReviewCountDocument).bind(null, variables),
    ...options
  }
    )};

useGetPendingReviewCountQuery.getKey = (variables?: GetPendingReviewCountQueryVariables) => variables === undefined ? ['GetPendingReviewCount'] : ['GetPendingReviewCount', variables];

export const UpdateZyusetuValueByApproveStepDocument = `
    mutation UpdateZyusetuValueByApproveStep($keyId: String!, $payloadId: String, $stepExecutionId: String!, $templateDescription: String, $value: FieldValueType!, $zyusetuId: String!) {
  updateZyusetuValueByApproveStep(
    keyId: $keyId
    payloadId: $payloadId
    stepExecutionId: $stepExecutionId
    templateDescription: $templateDescription
    value: $value
    zyusetuId: $zyusetuId
  )
}
    `;

export const useUpdateZyusetuValueByApproveStepMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateZyusetuValueByApproveStepMutation, TError, UpdateZyusetuValueByApproveStepMutationVariables, TContext>) => {
    
    return useMutation<UpdateZyusetuValueByApproveStepMutation, TError, UpdateZyusetuValueByApproveStepMutationVariables, TContext>(
      {
    mutationKey: ['UpdateZyusetuValueByApproveStep'],
    mutationFn: useFetcher<UpdateZyusetuValueByApproveStepMutation, UpdateZyusetuValueByApproveStepMutationVariables>(UpdateZyusetuValueByApproveStepDocument),
    ...options
  }
    )};

export const InactivateFileDocument = `
    mutation inactivateFile($id: String!, $zyusetuId: String!) {
  inactivateFile(id: $id, zyusetuId: $zyusetuId)
}
    `;

export const useInactivateFileMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<InactivateFileMutation, TError, InactivateFileMutationVariables, TContext>) => {
    
    return useMutation<InactivateFileMutation, TError, InactivateFileMutationVariables, TContext>(
      {
    mutationKey: ['inactivateFile'],
    mutationFn: useFetcher<InactivateFileMutation, InactivateFileMutationVariables>(InactivateFileDocument),
    ...options
  }
    )};

export const UpdateRotationDocument = `
    mutation UpdateRotation($id: String!, $rotation: Float!) {
  updateRotation(id: $id, rotation: $rotation) {
    ...FileFragment
  }
}
    ${FileFragmentFragmentDoc}`;

export const useUpdateRotationMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRotationMutation, TError, UpdateRotationMutationVariables, TContext>) => {
    
    return useMutation<UpdateRotationMutation, TError, UpdateRotationMutationVariables, TContext>(
      {
    mutationKey: ['UpdateRotation'],
    mutationFn: useFetcher<UpdateRotationMutation, UpdateRotationMutationVariables>(UpdateRotationDocument),
    ...options
  }
    )};

export const CreateFileFromTextDocument = `
    mutation CreateFileFromText($zyusetuId: String!, $text: String!, $fileType: FileType!, $title: String!) {
  createFileFromText(
    zyusetuId: $zyusetuId
    text: $text
    fileType: $fileType
    title: $title
  ) {
    ...FileFragment
  }
}
    ${FileFragmentFragmentDoc}`;

export const useCreateFileFromTextMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFileFromTextMutation, TError, CreateFileFromTextMutationVariables, TContext>) => {
    
    return useMutation<CreateFileFromTextMutation, TError, CreateFileFromTextMutationVariables, TContext>(
      {
    mutationKey: ['CreateFileFromText'],
    mutationFn: useFetcher<CreateFileFromTextMutation, CreateFileFromTextMutationVariables>(CreateFileFromTextDocument),
    ...options
  }
    )};

export const SearchRealEstateTransactionSpecialistsDocument = `
    query SearchRealEstateTransactionSpecialists($searchString: String!) {
  searchRealEstateTransactionSpecialists(searchString: $searchString) {
    ...RealEstateTransactionSpecialistFragment
  }
}
    ${RealEstateTransactionSpecialistFragmentFragmentDoc}`;

export const useSearchRealEstateTransactionSpecialistsQuery = <
      TData = SearchRealEstateTransactionSpecialistsQuery,
      TError = GraphqlError
    >(
      variables: SearchRealEstateTransactionSpecialistsQueryVariables,
      options?: Omit<UseQueryOptions<SearchRealEstateTransactionSpecialistsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchRealEstateTransactionSpecialistsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchRealEstateTransactionSpecialistsQuery, TError, TData>(
      {
    queryKey: ['SearchRealEstateTransactionSpecialists', variables],
    queryFn: useFetcher<SearchRealEstateTransactionSpecialistsQuery, SearchRealEstateTransactionSpecialistsQueryVariables>(SearchRealEstateTransactionSpecialistsDocument).bind(null, variables),
    ...options
  }
    )};

useSearchRealEstateTransactionSpecialistsQuery.getKey = (variables: SearchRealEstateTransactionSpecialistsQueryVariables) => ['SearchRealEstateTransactionSpecialists', variables];

export const SearchRealEstateBrokersDocument = `
    query SearchRealEstateBrokers($searchString: String!) {
  searchRealEstateBrokers(searchString: $searchString) {
    ...RealEstateBrokerFragment
  }
}
    ${RealEstateBrokerFragmentFragmentDoc}`;

export const useSearchRealEstateBrokersQuery = <
      TData = SearchRealEstateBrokersQuery,
      TError = GraphqlError
    >(
      variables: SearchRealEstateBrokersQueryVariables,
      options?: Omit<UseQueryOptions<SearchRealEstateBrokersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchRealEstateBrokersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchRealEstateBrokersQuery, TError, TData>(
      {
    queryKey: ['SearchRealEstateBrokers', variables],
    queryFn: useFetcher<SearchRealEstateBrokersQuery, SearchRealEstateBrokersQueryVariables>(SearchRealEstateBrokersDocument).bind(null, variables),
    ...options
  }
    )};

useSearchRealEstateBrokersQuery.getKey = (variables: SearchRealEstateBrokersQueryVariables) => ['SearchRealEstateBrokers', variables];

export const SearchManagementCompaniesDocument = `
    query SearchManagementCompanies($searchString: String!) {
  searchManagementCompanies(searchString: $searchString) {
    ...ManagementCompanyFragment
  }
}
    ${ManagementCompanyFragmentFragmentDoc}`;

export const useSearchManagementCompaniesQuery = <
      TData = SearchManagementCompaniesQuery,
      TError = GraphqlError
    >(
      variables: SearchManagementCompaniesQueryVariables,
      options?: Omit<UseQueryOptions<SearchManagementCompaniesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchManagementCompaniesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchManagementCompaniesQuery, TError, TData>(
      {
    queryKey: ['SearchManagementCompanies', variables],
    queryFn: useFetcher<SearchManagementCompaniesQuery, SearchManagementCompaniesQueryVariables>(SearchManagementCompaniesDocument).bind(null, variables),
    ...options
  }
    )};

useSearchManagementCompaniesQuery.getKey = (variables: SearchManagementCompaniesQueryVariables) => ['SearchManagementCompanies', variables];

export const GetManagementCompanyDocument = `
    query GetManagementCompany($id: String!) {
  getManagementCompany(id: $id) {
    ...ManagementCompanyFragment
  }
}
    ${ManagementCompanyFragmentFragmentDoc}`;

export const useGetManagementCompanyQuery = <
      TData = GetManagementCompanyQuery,
      TError = GraphqlError
    >(
      variables: GetManagementCompanyQueryVariables,
      options?: Omit<UseQueryOptions<GetManagementCompanyQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetManagementCompanyQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetManagementCompanyQuery, TError, TData>(
      {
    queryKey: ['GetManagementCompany', variables],
    queryFn: useFetcher<GetManagementCompanyQuery, GetManagementCompanyQueryVariables>(GetManagementCompanyDocument).bind(null, variables),
    ...options
  }
    )};

useGetManagementCompanyQuery.getKey = (variables: GetManagementCompanyQueryVariables) => ['GetManagementCompany', variables];

export const CreateManagementCompanyDocument = `
    mutation CreateManagementCompany($input: CreateManagementCompanyInput!) {
  createManagementCompany(input: $input) {
    ...ManagementCompanyFragment
  }
}
    ${ManagementCompanyFragmentFragmentDoc}`;

export const useCreateManagementCompanyMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<CreateManagementCompanyMutation, TError, CreateManagementCompanyMutationVariables, TContext>) => {
    
    return useMutation<CreateManagementCompanyMutation, TError, CreateManagementCompanyMutationVariables, TContext>(
      {
    mutationKey: ['CreateManagementCompany'],
    mutationFn: useFetcher<CreateManagementCompanyMutation, CreateManagementCompanyMutationVariables>(CreateManagementCompanyDocument),
    ...options
  }
    )};

export const UpdateManagementCompanyDocument = `
    mutation UpdateManagementCompany($id: String!, $input: CreateManagementCompanyInput!) {
  updateManagementCompany(id: $id, input: $input) {
    ...ManagementCompanyFragment
  }
}
    ${ManagementCompanyFragmentFragmentDoc}`;

export const useUpdateManagementCompanyMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateManagementCompanyMutation, TError, UpdateManagementCompanyMutationVariables, TContext>) => {
    
    return useMutation<UpdateManagementCompanyMutation, TError, UpdateManagementCompanyMutationVariables, TContext>(
      {
    mutationKey: ['UpdateManagementCompany'],
    mutationFn: useFetcher<UpdateManagementCompanyMutation, UpdateManagementCompanyMutationVariables>(UpdateManagementCompanyDocument),
    ...options
  }
    )};

export const SearchBankAccountsDocument = `
    query SearchBankAccounts($searchString: String!) {
  searchBankAccounts(searchString: $searchString) {
    ...BankAccountFragment
  }
}
    ${BankAccountFragmentFragmentDoc}`;

export const useSearchBankAccountsQuery = <
      TData = SearchBankAccountsQuery,
      TError = GraphqlError
    >(
      variables: SearchBankAccountsQueryVariables,
      options?: Omit<UseQueryOptions<SearchBankAccountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchBankAccountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchBankAccountsQuery, TError, TData>(
      {
    queryKey: ['SearchBankAccounts', variables],
    queryFn: useFetcher<SearchBankAccountsQuery, SearchBankAccountsQueryVariables>(SearchBankAccountsDocument).bind(null, variables),
    ...options
  }
    )};

useSearchBankAccountsQuery.getKey = (variables: SearchBankAccountsQueryVariables) => ['SearchBankAccounts', variables];

export const GetBankAccountDocument = `
    query GetBankAccount($id: String!) {
  getBankAccount(id: $id) {
    ...BankAccountFragment
  }
}
    ${BankAccountFragmentFragmentDoc}`;

export const useGetBankAccountQuery = <
      TData = GetBankAccountQuery,
      TError = GraphqlError
    >(
      variables: GetBankAccountQueryVariables,
      options?: Omit<UseQueryOptions<GetBankAccountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBankAccountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBankAccountQuery, TError, TData>(
      {
    queryKey: ['GetBankAccount', variables],
    queryFn: useFetcher<GetBankAccountQuery, GetBankAccountQueryVariables>(GetBankAccountDocument).bind(null, variables),
    ...options
  }
    )};

useGetBankAccountQuery.getKey = (variables: GetBankAccountQueryVariables) => ['GetBankAccount', variables];

export const CreateBankAccountDocument = `
    mutation CreateBankAccount($input: CreateBankAccountInput!) {
  createBankAccount(input: $input) {
    ...BankAccountFragment
  }
}
    ${BankAccountFragmentFragmentDoc}`;

export const useCreateBankAccountMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<CreateBankAccountMutation, TError, CreateBankAccountMutationVariables, TContext>) => {
    
    return useMutation<CreateBankAccountMutation, TError, CreateBankAccountMutationVariables, TContext>(
      {
    mutationKey: ['CreateBankAccount'],
    mutationFn: useFetcher<CreateBankAccountMutation, CreateBankAccountMutationVariables>(CreateBankAccountDocument),
    ...options
  }
    )};

export const UpdateBankAccountDocument = `
    mutation UpdateBankAccount($id: String!, $input: CreateBankAccountInput!) {
  updateBankAccount(id: $id, input: $input) {
    ...BankAccountFragment
  }
}
    ${BankAccountFragmentFragmentDoc}`;

export const useUpdateBankAccountMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBankAccountMutation, TError, UpdateBankAccountMutationVariables, TContext>) => {
    
    return useMutation<UpdateBankAccountMutation, TError, UpdateBankAccountMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBankAccount'],
    mutationFn: useFetcher<UpdateBankAccountMutation, UpdateBankAccountMutationVariables>(UpdateBankAccountDocument),
    ...options
  }
    )};

export const CreateRealEstateBrokerDocument = `
    mutation CreateRealEstateBroker($input: CreateRealEstateBrokerInput!) {
  createRealEstateBroker(input: $input) {
    ...RealEstateBrokerFragment
  }
}
    ${RealEstateBrokerFragmentFragmentDoc}`;

export const useCreateRealEstateBrokerMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<CreateRealEstateBrokerMutation, TError, CreateRealEstateBrokerMutationVariables, TContext>) => {
    
    return useMutation<CreateRealEstateBrokerMutation, TError, CreateRealEstateBrokerMutationVariables, TContext>(
      {
    mutationKey: ['CreateRealEstateBroker'],
    mutationFn: useFetcher<CreateRealEstateBrokerMutation, CreateRealEstateBrokerMutationVariables>(CreateRealEstateBrokerDocument),
    ...options
  }
    )};

export const CreateRealEstateTransactionSpecialistDocument = `
    mutation CreateRealEstateTransactionSpecialist($input: CreateRealEstateTransactionSpecialistInput!) {
  createRealEstateTransactionSpecialist(input: $input) {
    ...RealEstateTransactionSpecialistFragment
  }
}
    ${RealEstateTransactionSpecialistFragmentFragmentDoc}`;

export const useCreateRealEstateTransactionSpecialistMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<CreateRealEstateTransactionSpecialistMutation, TError, CreateRealEstateTransactionSpecialistMutationVariables, TContext>) => {
    
    return useMutation<CreateRealEstateTransactionSpecialistMutation, TError, CreateRealEstateTransactionSpecialistMutationVariables, TContext>(
      {
    mutationKey: ['CreateRealEstateTransactionSpecialist'],
    mutationFn: useFetcher<CreateRealEstateTransactionSpecialistMutation, CreateRealEstateTransactionSpecialistMutationVariables>(CreateRealEstateTransactionSpecialistDocument),
    ...options
  }
    )};

export const MeDocument = `
    query Me {
  me {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${OrganizationUsageFragmentFragmentDoc}
${OrganizationUsageLimitFragmentFragmentDoc}`;

export const useMeQuery = <
      TData = MeQuery,
      TError = GraphqlError
    >(
      variables?: MeQueryVariables,
      options?: Omit<UseQueryOptions<MeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Me'] : ['Me', variables],
    queryFn: useFetcher<MeQuery, MeQueryVariables>(MeDocument).bind(null, variables),
    ...options
  }
    )};

useMeQuery.getKey = (variables?: MeQueryVariables) => variables === undefined ? ['Me'] : ['Me', variables];

export const SearchUsersDocument = `
    query SearchUsers($searchText: String!) {
  searchUsers(searchText: $searchText) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${OrganizationUsageFragmentFragmentDoc}
${OrganizationUsageLimitFragmentFragmentDoc}`;

export const useSearchUsersQuery = <
      TData = SearchUsersQuery,
      TError = GraphqlError
    >(
      variables: SearchUsersQueryVariables,
      options?: Omit<UseQueryOptions<SearchUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchUsersQuery, TError, TData>(
      {
    queryKey: ['SearchUsers', variables],
    queryFn: useFetcher<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument).bind(null, variables),
    ...options
  }
    )};

useSearchUsersQuery.getKey = (variables: SearchUsersQueryVariables) => ['SearchUsers', variables];

export const GetZyusetuByIdDocument = `
    query GetZyusetuById($id: String!) {
  getZyusetuById(id: $id) {
    ...ZyusetuFragment
  }
}
    ${ZyusetuFragmentFragmentDoc}
${ApprovalFlowFragmentFragmentDoc}
${ApprovalStepFragmentFragmentDoc}
${ApprovalStepExecutionFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${OrganizationUsageFragmentFragmentDoc}
${OrganizationUsageLimitFragmentFragmentDoc}
${FileFragmentFragmentDoc}
${ZyusetuTemplateFragmentFragmentDoc}
${ZyusetuFieldSectionFragmentFragmentDoc}
${ZyusetuFieldKeyFragmentFragmentDoc}
${ZyusetuFieldDefaultValueFragmentFragmentDoc}
${ZyusetuFieldValueAnalyzedPayloadFragmentFragmentDoc}
${ZyusetuFieldValueFragmentFragmentDoc}
${ZyusetuFieldChangedValueFragmentFragmentDoc}
${ZyusetuFieldKeyValueTemplateFragmentFragmentDoc}
${RealEstateTransactionSpecialistFragmentFragmentDoc}
${RealEstateBrokerFragmentFragmentDoc}`;

export const useGetZyusetuByIdQuery = <
      TData = GetZyusetuByIdQuery,
      TError = GraphqlError
    >(
      variables: GetZyusetuByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetZyusetuByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetZyusetuByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetZyusetuByIdQuery, TError, TData>(
      {
    queryKey: ['GetZyusetuById', variables],
    queryFn: useFetcher<GetZyusetuByIdQuery, GetZyusetuByIdQueryVariables>(GetZyusetuByIdDocument).bind(null, variables),
    ...options
  }
    )};

useGetZyusetuByIdQuery.getKey = (variables: GetZyusetuByIdQueryVariables) => ['GetZyusetuById', variables];

export const SearchZyusetuTemplateDocument = `
    query SearchZyusetuTemplate($zyusetuType: ZyusetuType!, $rentGuaranteeType: RentGuaranteeType, $rentType: RentType, $searchString: String) {
  searchZyusetuTemplates(
    rentGuaranteeType: $rentGuaranteeType
    rentType: $rentType
    searchString: $searchString
    zyusetuType: $zyusetuType
  ) {
    ...ZyusetuTemplateFragment
  }
}
    ${ZyusetuTemplateFragmentFragmentDoc}
${ZyusetuFieldSectionFragmentFragmentDoc}
${ZyusetuFieldKeyFragmentFragmentDoc}
${ZyusetuFieldDefaultValueFragmentFragmentDoc}
${ZyusetuFieldValueAnalyzedPayloadFragmentFragmentDoc}
${ZyusetuFieldValueFragmentFragmentDoc}
${ZyusetuFieldChangedValueFragmentFragmentDoc}
${ZyusetuFieldKeyValueTemplateFragmentFragmentDoc}`;

export const useSearchZyusetuTemplateQuery = <
      TData = SearchZyusetuTemplateQuery,
      TError = GraphqlError
    >(
      variables: SearchZyusetuTemplateQueryVariables,
      options?: Omit<UseQueryOptions<SearchZyusetuTemplateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchZyusetuTemplateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchZyusetuTemplateQuery, TError, TData>(
      {
    queryKey: ['SearchZyusetuTemplate', variables],
    queryFn: useFetcher<SearchZyusetuTemplateQuery, SearchZyusetuTemplateQueryVariables>(SearchZyusetuTemplateDocument).bind(null, variables),
    ...options
  }
    )};

useSearchZyusetuTemplateQuery.getKey = (variables: SearchZyusetuTemplateQueryVariables) => ['SearchZyusetuTemplate', variables];

export const CreateZyusetuDocument = `
    mutation CreateZyusetu($fileIds: [String!], $templateId: String!, $title: String!) {
  createZyusetu(fileIds: $fileIds, templateId: $templateId, title: $title) {
    ...ZyusetuFragment
  }
}
    ${ZyusetuFragmentFragmentDoc}
${ApprovalFlowFragmentFragmentDoc}
${ApprovalStepFragmentFragmentDoc}
${ApprovalStepExecutionFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${OrganizationUsageFragmentFragmentDoc}
${OrganizationUsageLimitFragmentFragmentDoc}
${FileFragmentFragmentDoc}
${ZyusetuTemplateFragmentFragmentDoc}
${ZyusetuFieldSectionFragmentFragmentDoc}
${ZyusetuFieldKeyFragmentFragmentDoc}
${ZyusetuFieldDefaultValueFragmentFragmentDoc}
${ZyusetuFieldValueAnalyzedPayloadFragmentFragmentDoc}
${ZyusetuFieldValueFragmentFragmentDoc}
${ZyusetuFieldChangedValueFragmentFragmentDoc}
${ZyusetuFieldKeyValueTemplateFragmentFragmentDoc}
${RealEstateTransactionSpecialistFragmentFragmentDoc}
${RealEstateBrokerFragmentFragmentDoc}`;

export const useCreateZyusetuMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<CreateZyusetuMutation, TError, CreateZyusetuMutationVariables, TContext>) => {
    
    return useMutation<CreateZyusetuMutation, TError, CreateZyusetuMutationVariables, TContext>(
      {
    mutationKey: ['CreateZyusetu'],
    mutationFn: useFetcher<CreateZyusetuMutation, CreateZyusetuMutationVariables>(CreateZyusetuDocument),
    ...options
  }
    )};

export const AnalyzeZyusetuFilesDocument = `
    mutation AnalyzeZyusetuFiles($fileIds: [String!]!, $zyusetuId: String!) {
  analyzeZyusetuFiles(fileIds: $fileIds, zyusetuId: $zyusetuId) {
    ...ZyusetuFragment
  }
}
    ${ZyusetuFragmentFragmentDoc}
${ApprovalFlowFragmentFragmentDoc}
${ApprovalStepFragmentFragmentDoc}
${ApprovalStepExecutionFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${OrganizationUsageFragmentFragmentDoc}
${OrganizationUsageLimitFragmentFragmentDoc}
${FileFragmentFragmentDoc}
${ZyusetuTemplateFragmentFragmentDoc}
${ZyusetuFieldSectionFragmentFragmentDoc}
${ZyusetuFieldKeyFragmentFragmentDoc}
${ZyusetuFieldDefaultValueFragmentFragmentDoc}
${ZyusetuFieldValueAnalyzedPayloadFragmentFragmentDoc}
${ZyusetuFieldValueFragmentFragmentDoc}
${ZyusetuFieldChangedValueFragmentFragmentDoc}
${ZyusetuFieldKeyValueTemplateFragmentFragmentDoc}
${RealEstateTransactionSpecialistFragmentFragmentDoc}
${RealEstateBrokerFragmentFragmentDoc}`;

export const useAnalyzeZyusetuFilesMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<AnalyzeZyusetuFilesMutation, TError, AnalyzeZyusetuFilesMutationVariables, TContext>) => {
    
    return useMutation<AnalyzeZyusetuFilesMutation, TError, AnalyzeZyusetuFilesMutationVariables, TContext>(
      {
    mutationKey: ['AnalyzeZyusetuFiles'],
    mutationFn: useFetcher<AnalyzeZyusetuFilesMutation, AnalyzeZyusetuFilesMutationVariables>(AnalyzeZyusetuFilesDocument),
    ...options
  }
    )};

export const UpdateZyusetuValueDocument = `
    mutation UpdateZyusetuValue($zyusetuId: String!, $fieldId: String!, $value: FieldValueType!, $payloadId: String, $templateDescription: String) {
  updateZyusetuValue(
    zyusetuId: $zyusetuId
    keyId: $fieldId
    value: $value
    payloadId: $payloadId
    templateDescription: $templateDescription
  )
}
    `;

export const useUpdateZyusetuValueMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateZyusetuValueMutation, TError, UpdateZyusetuValueMutationVariables, TContext>) => {
    
    return useMutation<UpdateZyusetuValueMutation, TError, UpdateZyusetuValueMutationVariables, TContext>(
      {
    mutationKey: ['UpdateZyusetuValue'],
    mutationFn: useFetcher<UpdateZyusetuValueMutation, UpdateZyusetuValueMutationVariables>(UpdateZyusetuValueDocument),
    ...options
  }
    )};

export const VerifyZyusetuValueDocument = `
    mutation VerifyZyusetuValue($zyusetuId: String!, $input: [VerifyZyusetuValueInput!]!) {
  verifyZyusetuValue(zyusetuId: $zyusetuId, input: $input) {
    ...ZyusetuFragment
  }
}
    ${ZyusetuFragmentFragmentDoc}
${ApprovalFlowFragmentFragmentDoc}
${ApprovalStepFragmentFragmentDoc}
${ApprovalStepExecutionFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${OrganizationUsageFragmentFragmentDoc}
${OrganizationUsageLimitFragmentFragmentDoc}
${FileFragmentFragmentDoc}
${ZyusetuTemplateFragmentFragmentDoc}
${ZyusetuFieldSectionFragmentFragmentDoc}
${ZyusetuFieldKeyFragmentFragmentDoc}
${ZyusetuFieldDefaultValueFragmentFragmentDoc}
${ZyusetuFieldValueAnalyzedPayloadFragmentFragmentDoc}
${ZyusetuFieldValueFragmentFragmentDoc}
${ZyusetuFieldChangedValueFragmentFragmentDoc}
${ZyusetuFieldKeyValueTemplateFragmentFragmentDoc}
${RealEstateTransactionSpecialistFragmentFragmentDoc}
${RealEstateBrokerFragmentFragmentDoc}`;

export const useVerifyZyusetuValueMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<VerifyZyusetuValueMutation, TError, VerifyZyusetuValueMutationVariables, TContext>) => {
    
    return useMutation<VerifyZyusetuValueMutation, TError, VerifyZyusetuValueMutationVariables, TContext>(
      {
    mutationKey: ['VerifyZyusetuValue'],
    mutationFn: useFetcher<VerifyZyusetuValueMutation, VerifyZyusetuValueMutationVariables>(VerifyZyusetuValueDocument),
    ...options
  }
    )};

export const CreateZyusetuDocumentDocument = `
    mutation CreateZyusetuDocument($zyusetuId: String!) {
  createZyusetuDocument(zyusetuId: $zyusetuId) {
    ...FileFragment
  }
}
    ${FileFragmentFragmentDoc}`;

export const useCreateZyusetuDocumentMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<CreateZyusetuDocumentMutation, TError, CreateZyusetuDocumentMutationVariables, TContext>) => {
    
    return useMutation<CreateZyusetuDocumentMutation, TError, CreateZyusetuDocumentMutationVariables, TContext>(
      {
    mutationKey: ['CreateZyusetuDocument'],
    mutationFn: useFetcher<CreateZyusetuDocumentMutation, CreateZyusetuDocumentMutationVariables>(CreateZyusetuDocumentDocument),
    ...options
  }
    )};

export const SetRealEstateBrokerToZyusetuDocument = `
    mutation SetRealEstateBrokerToZyusetu($zyusetuId: String!, $brokerIds: [String!]!) {
  setRealEstateBrokerToZyusetu(zyusetuId: $zyusetuId, brokerIds: $brokerIds)
}
    `;

export const useSetRealEstateBrokerToZyusetuMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<SetRealEstateBrokerToZyusetuMutation, TError, SetRealEstateBrokerToZyusetuMutationVariables, TContext>) => {
    
    return useMutation<SetRealEstateBrokerToZyusetuMutation, TError, SetRealEstateBrokerToZyusetuMutationVariables, TContext>(
      {
    mutationKey: ['SetRealEstateBrokerToZyusetu'],
    mutationFn: useFetcher<SetRealEstateBrokerToZyusetuMutation, SetRealEstateBrokerToZyusetuMutationVariables>(SetRealEstateBrokerToZyusetuDocument),
    ...options
  }
    )};

export const SetRealEstateTransactionSpecialistToZyusetuDocument = `
    mutation SetRealEstateTransactionSpecialistToZyusetu($zyusetuId: String!, $specialistIds: [String!]!) {
  setRealEstateTransactionSpecialistToZyusetu(
    zyusetuId: $zyusetuId
    specialistIds: $specialistIds
  )
}
    `;

export const useSetRealEstateTransactionSpecialistToZyusetuMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<SetRealEstateTransactionSpecialistToZyusetuMutation, TError, SetRealEstateTransactionSpecialistToZyusetuMutationVariables, TContext>) => {
    
    return useMutation<SetRealEstateTransactionSpecialistToZyusetuMutation, TError, SetRealEstateTransactionSpecialistToZyusetuMutationVariables, TContext>(
      {
    mutationKey: ['SetRealEstateTransactionSpecialistToZyusetu'],
    mutationFn: useFetcher<SetRealEstateTransactionSpecialistToZyusetuMutation, SetRealEstateTransactionSpecialistToZyusetuMutationVariables>(SetRealEstateTransactionSpecialistToZyusetuDocument),
    ...options
  }
    )};

export const GetZyusetuSimpleDocument = `
    query GetZyusetuSimple($skip: Int!, $take: Int!, $search: ZyusetuSearchInput) {
  getZyusetuSimple(paginate: {skip: $skip, take: $take}, search: $search) {
    items {
      ...ZyusetuSimpleFragment
    }
    total
  }
}
    ${ZyusetuSimpleFragmentFragmentDoc}
${FileFragmentFragmentDoc}
${ApprovalStepExecutionFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${OrganizationUsageFragmentFragmentDoc}
${OrganizationUsageLimitFragmentFragmentDoc}`;

export const useGetZyusetuSimpleQuery = <
      TData = GetZyusetuSimpleQuery,
      TError = GraphqlError
    >(
      variables: GetZyusetuSimpleQueryVariables,
      options?: Omit<UseQueryOptions<GetZyusetuSimpleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetZyusetuSimpleQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetZyusetuSimpleQuery, TError, TData>(
      {
    queryKey: ['GetZyusetuSimple', variables],
    queryFn: useFetcher<GetZyusetuSimpleQuery, GetZyusetuSimpleQueryVariables>(GetZyusetuSimpleDocument).bind(null, variables),
    ...options
  }
    )};

useGetZyusetuSimpleQuery.getKey = (variables: GetZyusetuSimpleQueryVariables) => ['GetZyusetuSimple', variables];

export const UpdateZyusetuDefaultValueDocument = `
    mutation UpdateZyusetuDefaultValue($keyId: String!, $value: FieldValueType!, $zyusetuDefaultValueId: String) {
  updateZyusetuDefaultValue(
    keyId: $keyId
    value: $value
    zyusetuDefaultValueId: $zyusetuDefaultValueId
  )
}
    `;

export const useUpdateZyusetuDefaultValueMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateZyusetuDefaultValueMutation, TError, UpdateZyusetuDefaultValueMutationVariables, TContext>) => {
    
    return useMutation<UpdateZyusetuDefaultValueMutation, TError, UpdateZyusetuDefaultValueMutationVariables, TContext>(
      {
    mutationKey: ['UpdateZyusetuDefaultValue'],
    mutationFn: useFetcher<UpdateZyusetuDefaultValueMutation, UpdateZyusetuDefaultValueMutationVariables>(UpdateZyusetuDefaultValueDocument),
    ...options
  }
    )};

export const DeleteZyusetuDefaultValueDocument = `
    mutation DeleteZyusetuDefaultValue($zyusetuDefaultValueId: String!) {
  deleteZyusetuDefaultValue(zyusetuDefaultValueId: $zyusetuDefaultValueId)
}
    `;

export const useDeleteZyusetuDefaultValueMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteZyusetuDefaultValueMutation, TError, DeleteZyusetuDefaultValueMutationVariables, TContext>) => {
    
    return useMutation<DeleteZyusetuDefaultValueMutation, TError, DeleteZyusetuDefaultValueMutationVariables, TContext>(
      {
    mutationKey: ['DeleteZyusetuDefaultValue'],
    mutationFn: useFetcher<DeleteZyusetuDefaultValueMutation, DeleteZyusetuDefaultValueMutationVariables>(DeleteZyusetuDefaultValueDocument),
    ...options
  }
    )};

export const CreateZyusetuValueTemplateDocument = `
    mutation CreateZyusetuValueTemplate($keyId: String!, $input: CreateZyusetuValueTemplateInput!) {
  createZyusetuValueTemplate(keyId: $keyId, input: $input) {
    ...ZyusetuFieldKeyValueTemplateFragment
  }
}
    ${ZyusetuFieldKeyValueTemplateFragmentFragmentDoc}`;

export const useCreateZyusetuValueTemplateMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<CreateZyusetuValueTemplateMutation, TError, CreateZyusetuValueTemplateMutationVariables, TContext>) => {
    
    return useMutation<CreateZyusetuValueTemplateMutation, TError, CreateZyusetuValueTemplateMutationVariables, TContext>(
      {
    mutationKey: ['CreateZyusetuValueTemplate'],
    mutationFn: useFetcher<CreateZyusetuValueTemplateMutation, CreateZyusetuValueTemplateMutationVariables>(CreateZyusetuValueTemplateDocument),
    ...options
  }
    )};

export const UpdateZyusetuValueTemplateDocument = `
    mutation UpdateZyusetuValueTemplate($id: String!, $input: CreateZyusetuValueTemplateInput!) {
  updateZyusetuValueTemplate(id: $id, input: $input) {
    ...ZyusetuFieldKeyValueTemplateFragment
  }
}
    ${ZyusetuFieldKeyValueTemplateFragmentFragmentDoc}`;

export const useUpdateZyusetuValueTemplateMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateZyusetuValueTemplateMutation, TError, UpdateZyusetuValueTemplateMutationVariables, TContext>) => {
    
    return useMutation<UpdateZyusetuValueTemplateMutation, TError, UpdateZyusetuValueTemplateMutationVariables, TContext>(
      {
    mutationKey: ['UpdateZyusetuValueTemplate'],
    mutationFn: useFetcher<UpdateZyusetuValueTemplateMutation, UpdateZyusetuValueTemplateMutationVariables>(UpdateZyusetuValueTemplateDocument),
    ...options
  }
    )};

export const DeleteZyusetuValueTemplateDocument = `
    mutation DeleteZyusetuValueTemplate($id: String!) {
  deleteZyusetuValueTemplate(id: $id)
}
    `;

export const useDeleteZyusetuValueTemplateMutation = <
      TError = GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteZyusetuValueTemplateMutation, TError, DeleteZyusetuValueTemplateMutationVariables, TContext>) => {
    
    return useMutation<DeleteZyusetuValueTemplateMutation, TError, DeleteZyusetuValueTemplateMutationVariables, TContext>(
      {
    mutationKey: ['DeleteZyusetuValueTemplate'],
    mutationFn: useFetcher<DeleteZyusetuValueTemplateMutation, DeleteZyusetuValueTemplateMutationVariables>(DeleteZyusetuValueTemplateDocument),
    ...options
  }
    )};
